<template>
  <div class="accurate_market" style="min-width: 1066px">
    <!-- <top-title :name="'精准营销'" :desc="'此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~'" :showSet="true"></top-title> -->

    <div class="main_content" :style="{ 'margin-top': isEffectSend ? '0' : '20px' }">
      <div class="nav-box" v-if="isEffectSend">
        <span class="go-back" @click="goBack">返回列表</span>
      </div>
      <!-- 温馨提示 -->
        <div v-if="sendType == 2 || sendType == 3 || sendType == 15" class="topTis">
        <img src="@/assets/images/提示_黄.png" style="
                        display: inline-block;
                        position: absolute;
                        width: 14px;
                        height: 14px;
                        color: #ffffff;
                        left: 15px;
                        top: 15px;
                      " />
        <div class="desc" style="margin-left: 24px">
          <p>温馨提示：</p>
          <p class="setting-text">
            此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~
            <span style="cursor: pointer; margin-left: 10px" @click="setDialogVisible = true">去设置</span>
          </p>
          <p><span style="font-weight: bold;">1.审核规则</span></p>
          <p>
            （1）普通短信：提交<span style="color: red;">10W</span>条以上短信需人工审核，<span style="color: red;">审核时间为每工作日18点（建议商家提前一天创建活动）；</span>
          </p>
          <p>
            （2）<span style="color: red;">富信/卡片短信：使用前需经过运营商审核与条线运营审核模板，预计2-4个工作日，请至少提前2个工作日创建模板，模板审核通过后才可在短信发送任务中选上模板使用；</span>
          </p>
          <p><span style="font-weight: bold;">2.发送时间范围</span>（普通短信/富信/卡片短信）：早9:00-晚20:00（日常）</p>
          <p><span style="font-weight: bold;">3.日常频控规则:</span></p>
          <p>同一店铺 3 天内给同一手机号发送商家营销短信的条数不超过 1条;每个手机号每 1天只能收到 3条商家营销短信,每 2天只能收到 4条商家营销短信<span style="color: red;">（*商家营销短信包括普通短信、富信和卡片短信）</span></p>
        </div>
      </div>
      <div class="tip-box-global1" v-if="sendType == 4 || sendType == 5">
        <img src="@/assets/images/new_icon_waring_yellow.png" style="
                                                      display: inline-block;
                                                      width: 14px;
                                                      position: absolute;
                                                      height: 14px;
                                                      color: #ffffff;
                                                      margin: 3px 0px 0 -8px;
                                                    " />
        <div style="margin-left: 8px; line-height: 22px !important">
          根据京东服务市场最新规则，短信签名不得包含【京东】、【京东金融】、【京东云】、【京东到家】、【拍拍】、【易迅】、【京东支付】、【1号店】,详情请咨询在线客服。
          <a href="tencent://message/?uin=800152084&Site=在线客服&Menu=yes" target="_blank">
            <span class="qq">QQ交谈</span>
          </a>
        </div>
      </div>

      <!-- 第一步筛选人群 -->
      <div class="step1-box" v-if="sendType == 1">
        <div style="
                                                      height: 420px;
                                                      margin: 23px 0 0 11px;
                                                      position: absolute;
                                                      width: 1px;
                                                      background-color: #f6f6f6;
                                                    "></div>
        <div class="step-bar">
          <span class="serial" :style="{ background: globalBG }">1</span>
          <!-- <span class="division" :style="{ background: globalBG }"></span> -->
          <span class="name" style="margin-left: -10px">筛选人群</span>
        </div>
        <div class="form-item">
          <div class="item-label">活动主题：</div>
          <div class="item-value activity-theme">
            <el-input placeholder="可不填" v-model="formData.activityTitle" maxlength="50" show-word-limit></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">活动对象：</div>
          <div class="item-value">
            <div class="select-people-box">
              <div class="select-header">
                <el-button type="primary" @click="showPeopleDialog('0')" :disabled="computeLoading"
                  style="margin-right: 12px; font-size: 14px; height: 28px">选择人群</el-button>
                <span>已选</span>
                <span class="height-num" style="color: #fe4d45">{{
                  includePeople.length
                }}</span>
                <span>个人群</span>
                <div class="operation-wrapper">
                  <span>运算规则：</span>
                  <el-radio-group v-model="includeRule" :disabled="computeLoading">
                    <el-radio :label="1">合并</el-radio>
                    <el-radio :label="0">交集</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="people-group">
                <div class="group-item" v-for="(item, index) in includePeople" :key="index" :style="item.count > 0 ? '':'border-color:#FE4D45'">
                  <div class="group-name" >
                    {{ item.name || item.strategyName }}
                    <span :style="{color:item.count > 0 ? '#7f85e9':'#FE4D45'}">（{{ item.count }}）</span>
                  </div>
                  <div class="close" @click="delPeople('0', index)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label"></div>
          <div class="item-value">
            <el-checkbox v-model="isExcludeFlag" :disabled="computeLoading" :label="true" style="z-index: 0;">&nbsp;</el-checkbox>排除人群
          </div>
        </div>

        <div class="form-item" v-if="isExcludeFlag">
          <div class="item-label"></div>
          <div class="item-value">
            <div class="select-people-box">
              <div class="select-header">
                <el-button class="computeLoadingButtom" style="margin-right: 12px" :disabled="computeLoading"
                  @click="showPeopleDialog('1')">选择人群</el-button>
                <span>已选</span>
                <span class="height-num" style="color: #fe4d45">{{
                  excludePeople.length
                }}</span>
                <span>个人群</span>
                <div class="operation-wrapper">
                  <span>运算规则：</span>
                  <el-radio-group v-model="excludeRule" :disabled="computeLoading">
                    <el-radio :label="1">合并</el-radio>
                    <el-radio :label="0">交集</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="people-group">
                <div class="group-item" v-for="(item, index) in excludePeople" :key="index" :style="item.count > 0 ? '':'border-color:#FE4D45'">
                  <div class="group-name">
                    {{ item.name || item.strategyName
                    }}<span :style="{color:item.count > 0 ? '#7f85e9':'#FE4D45'}">（{{ item.count }}）</span>
                  </div>
                  <div class="close" @click="delPeople('1', index)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label"></div>
          <div class="item-value">
            过滤设置
            <div class="ask_content">
              <span class="question_icon" style="margin-left: 4px">?</span>
              <div class="ask-icon-select">
                <div>仅支持过滤黑名单pin，不支持过滤黑名单手机号</div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label"></div>
          <div class="item-value">
            <div class="select-people-box">
              <div class="select-header aacc">
                <el-checkbox id="select-header-color" :label="true" :disabled="computeLoading" v-model="blacklisted" style="z-index: 0;">
                  屏蔽黑名单
                </el-checkbox>
                <span @click="routerLinkOne" :style="{ color: '#7f85e9' }"
                  style="margin-left: 10px; cursor: pointer; margin-right: 20px">设置黑名单</span>
                <el-checkbox v-if="isPremissionShow" :label="true" :disabled="computeLoading"
                  v-model="filterAlreadySentFlag" style="z-index: 0;">
                  <span>屏蔽近</span>
                  <el-input v-model.number="filterDays" @keyup.native="limitInput($event)"
                    onblur="value=value.replace(/[^\d]/g,'')" style="width: 100px; padding: 0 6px">
                  </el-input>
                  <span>天已发送客户</span>
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 下一步按钮 -->
      <div class="next-line" v-if="sendType == 1">
        <div class="compute-people">
          <span class="item-name">人群运算结果：</span>
          <span>共筛选出</span>
          <span class="height-num" :style="{ color: globalBG }">{{
            sendPeopleNum
          }}</span>
          <span>人</span>
          <el-button class="handleCaculateButtom" @click="handleCaculate" :disabled="computeLoading"
            v-loading="computeLoading" style="font-size: 14px">点击运算</el-button>
          <!-- <div class="item-value"> -->
            <div class="ask_content">
              <span class="question_icon" style="margin-left: 14px">?</span>
              <div class="ask-icon-select">
                <div>当所选人群的人群类型为官方人群-数坊侧粉丝人群策略、官方人群-数坊侧会员重点人群策略时，人群数量需大于20才能进行运算</div>
              </div>
            </div>
          <!-- </div> -->
        </div>
        <!-- <el-button class="btn-group" @click="nextStep" type="primary">下一步</el-button> -->
      </div>

      <!-- 步骤二 发送短信 -->
      <div class="main_content_top" v-if="sendStep == 2" :style="{ 'margin-top': sendType == 1 ? '50px' : '','margin-bottom': formData.smsType == 1||formData.smsType == 2  ? '150px' : '' }">
        <div class="step-bar" v-if="sendType == 1">
          <span class="serial" :style="{ background: globalBG }">2</span>
          <!-- <span class="division" :style="{ background: globalBG }"></span> -->
          <span class="name" style="margin-left: -10px">编辑短信</span>
        </div>
        <!-- form表单 -->
        <el-form ref="formSearch" :model="formData" label-width="120px" style="width: 750px; display: inline-block">
          <el-form-item class="self-style" label="导入文件:" v-if="sendType == '5'">
            <div class="import-box">
              <div class="top-import">
                <el-button type="text" class="upload-btn" @click="handleShowInputPhone">上传文件</el-button>
                <span style="color: #7f85e9; margin-right: 5px; cursor: pointer"
                  @click="downloadTemplate('2')">EXCEL模板下载</span>
                <!-- <span style="color: #7F85E9">TXT模板下载</span> -->
                <p class="upload-num">
                  成功上传
                  <span class="num">{{ sendPeopleNum }}</span>个手机号码
                </p>
              </div>
              <div class="tip-box">
                <i class="el-icon-warning icon-waring"></i>
                <p>温馨提示</p>
                <p>
                  1.您可以导入xls/xlsx/csv/txt等格式的文件，文件中每行只能输入一个客户的记录，表格文件需在第一列输入手机号，请勿加上任何其他字符！
                </p>
                <p>2.无效或重复的手机号码会被过滤;</p>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="sendType == '4' && isEffectSend" label="发送对象:">
            <el-popover placement="bottom-start" width="500" trigger="click">
              <div>
                <el-radio-group v-model="effectRadio">
                  <el-radio @change="preCommitSend(false)" style="width: 200px; margin-top: 15px"
                    v-for="(item, index) in effectRadioList" :key="index" :label="item.value" :disabled="!(item.num > 0)">
                    {{ item.label }}</el-radio>
                </el-radio-group>
              </div>
              <el-button style="width: 210px" slot="reference">实际发送客户数（{{ sendPeopleNum }}）</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="发送对象:" v-if="sendType == '4' && !isEffectSend">
            <el-radio-group v-model="formData.type">
              <el-radio :label="1">输入手机号码</el-radio>
              <el-radio :label="2">上传手机号码</el-radio>
            </el-radio-group>
            <el-input v-if="formData.type == '1'" type="textarea" rows="4" @input="handleMobileInput"
              v-model="formData.inputMobileStr" placeholder="请输入手机号码，号码之间用','隔开"></el-input>
            <div v-if="formData.type == '2'">
              <!-- <div style="display: inline-block">导入文件：</div> -->
              <div class="import-box">
                <div class="top-import">
                  <el-button type="text" class="upload-btn" @click="handleShowInputPhone">上传文件</el-button>
                  <span style="color: #7f85e9; margin-right: 5px; cursor: pointer"
                    @click="downloadTemplate('1')">EXCEL模板下载</span>
                  <p class="upload-num">
                    成功上传
                    <span class="num">{{ sendPeopleNum }}</span>个手机号码
                  </p>
                </div>
                <div class="tip-box">
                  <i class="el-icon-warning icon-waring"></i>
                  <p>温馨提示</p>
                  <p>
                    1.您可以导入xls/xlsx/csv/txt等格式的文件，文件中每行只能输入一个客户的记录，表格文件需在第一列输入手机号，请勿加上任何其他字符！
                  </p>
                  <p>2.无效或重复的手机号码会被过滤;</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="sendType == '2' && isEffectSend" label="发送对象:">
            <el-popover placement="bottom-start" width="500" trigger="click">
              <div>
                <el-radio-group v-model="effectRadio">
                  <el-radio @change="preCommitSend(false)" style="width: 200px; margin-top: 15px"
                    v-for="(item, index) in effectRadioList" :key="index" :label="item.value" :disabled="!(item.num > 0)">
                    {{ item.label }}</el-radio>
                </el-radio-group>
              </div>
              <el-button style="width: 210px" slot="reference">实际发送客户数（{{ sendPeopleNum }}）</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="发送对象:" v-if="
            (sendType == '2' && !isEffectSend) ||
            sendType == '3' ||
            sendType == '15'
          ">
            <span>已选择</span>
            <i v-show="preLoading && (sendType == '3' || sendType == '15')" :style="{ color: globalBG }"
              class="el-icon-loading"></i>
            <span v-show="!(preLoading && (sendType == '3' || sendType == '15'))" class="height-num-x"
              :style="{ color: globalBG }">{{ sendPeopleNum }}</span>
            <span>{{isOlderSent? '订单':'位会员'}}</span>
            <!-- <span
              class="select_people"
              :style="{'color':globalBG,'border-color':globalBG}"
              @click="selectPeopleDialog=true"
              v-if="selCrowdName==''"
            >选择人群</span>
            <span
              class="select_people"
              :style="{'color':globalBG,'border-color':globalBG}"
              @click="selectPeopleDialog=true"
              v-if="selCrowdName!=''"
            >{{selCrowdName}}（{{selCrowdNum}}）</span>
            <span class="create_people" @click="toCreatePeople">创建人群</span>-->
          </el-form-item>

          <el-form-item label="活动主题:" v-if="
            sendType == '2' ||
            sendType == '3' ||
            sendType == '4' ||
            sendType == '15'
          ">
            <el-input v-model="formData.activityTitle" placeholder="可不填（50字以内）" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="" v-if="sendType == '5' && variableList && variableList.length > 0">
            <div class="variable-list">
              <div @click="insertContent(item)" :style="{ background: globalBG }" v-for="(item, index) in variableList"
                :key="index" class="variable-item">
                {{ item }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="短信类型:">
            <el-radio-group v-model="formData.smsType">
              <el-radio :label="0">普通短信</el-radio>
              <el-radio :label="1">富信</el-radio>
              <el-radio :label="2">卡片短信</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 类型为普通短信显示 -->
          <el-form-item label="编辑短信:" v-if="formData.smsType == 0">
            <div class="textarea">
              <el-input type="textarea" style="font-size: 14px; font-family: Microsoft YaHei" :rows="6" id="smsContent"
                placeholder="请输入内容" v-model="formData.content" @input="handc" @paste.native="shopLinkCheck($event)"></el-input>
              <div class="footInfo">
                <div>
                  <button class="select" @click.prevent="templateShow = true">
                    选择模板
                  </button>
                  <button class="keep" @click.prevent="handleShowModule">
                    保存模板
                  </button>
                  <span>
                    已输入
                    <span :style="{ color: globalBG }">{{
                      sendInfoLength
                    }}</span>
                    个字（含签名及退订文字），预计
                    <span :style="{ color: globalBG }">{{
                      Math.ceil(
                        sendInfoLength > 70
                          ? sendInfoLength / 67
                          : sendInfoLength / 70
                      )
                    }}</span>
                    条短信
                  </span>
                </div>
                <div>
                  <div class="ask_content">
                    <span style="font-weight: normal; margin-left: 12px" class="contentButtom">计费规则</span>
                    <span class="question_icon" style="margin-left: 4px">?</span>
                    <div class="ask-icon-select">
                      <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                      <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                      <div>
                        3.带标签短信以实际发送为准，有可能超过默认字数。
                      </div>
                      <!-- <div>4."签名"包含在字数中。</div> -->
                      <div>4."签名"与"{{ TTip }}"包含在字数中。</div>
                      <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                      <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footTips" style="height: 180px; position: relative">
              <img src="@/assets/images/new_icon_waring_yellow.png" style="
                                                            display: inline-block;
                                                            float: left;
                                                            position: absolute;
                                                            width: 14px;
                                                            height: 14px;
                                                            color: #ffffff;
                                                            margin: 0px 4px 0 0;
                                                            top: 9px;
                                                          " />
              <span style="margin-left: 22px; line-height: 21px">(1)
                短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链；
                <br />
                (2) 生成短链后建议复制到手机浏览器打开确保短链接能正常打开。
                <br />
                (3) 包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接
                (示例：点击加购x商品详情页> 3.cn/1l-dAxxx)
                <br />
                (4) 短网址点击数据由官方返回，部分链接（如含中间页跳转，非原始链接）官方不支持埋点，因此无短网址点击数据
                <br/>
                (5) 原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
              </span>
            </div>
            <div class="info" v-if="smsType == 3">
              <img src="@/assets/images/new_icon_reminder.png" style="
                                                            display: inline-block;
                                                            float: left;
                                                            width: 14px;
                                                            height: 14px;
                                                            color: #ffffff;
                                                            margin: 3px 0 0 0;
                                                          " />
              <div>
                <p>
                  （1）输入网址前、后加空格，否则无法正常打开；链接建议实时转换生成，若使用复制粘贴链
                  <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;接，则无法统计点击转化数据;
                </p>
                <p>
                  （2）发根据运营商规定，请不要发送“返现”
                  “加微信”相关内容的短信;
                </p>
                <p>（3）短信内容请不要含有繁体字。</p>
              </div>
            </div>
          </el-form-item>
          <!-- 类型为富信显示 -->
          <el-form-item :label="isMediaQualification?'富信模板:':''" v-if="formData.smsType == 1" v-loading="editLoading">
            <div v-if="isMediaQualification">
              <el-select v-model="mediaId" @change="changeMedia" filterable>
                <el-option v-for="(item, index) in mediaOptionList" :key="index" :value="item.id"
                  :label="item.name"></el-option>
              </el-select>
              <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addMediaModule">添加模板</span>
            </div>
            <div v-else>
              <div class="notShow">
                <img src="@/assets/images/未开通富信.png" alt="">
                <p>您还未开通富信营销功能</p>
                <div class="bottom-btn">
                  <button class="select" style="width: 136px;" @click.prevent="checkOut">
                    查看富信营销案例
                  </button>
                  <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
                    去提交资质申请开通
                  </button>
                </div>
              </div>
              <sms-info-template v-if="smsInfoTemplateShow" @close="handleCloseSmsInfo1" :isShow="smsInfoTemplateShow" />
            </div>
          </el-form-item>
          <el-form-item label="卡片模板:" v-if="formData.smsType == 2">
            <div v-if="isMediaQualification">
              <el-select v-model="cardId" @change="changeCard"  filterable>
                <el-option v-for="(item, index) in cardOptionList" :key="index" :value="item.id"
                  :label="item.name"></el-option>
              </el-select>
              <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardModule">添加模板</span>
            </div>
            <div v-else>
              <div class="notShow">
                <img src="@/assets/images/未开通富信.png" alt="">
                <p>您还未开通卡片短信营销功能</p>
                <div class="bottom-btn">
                  <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
                    去提交资质申请开通
                  </button>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="回落类型:" v-if="formData.smsType == 2 && isMediaQualification">
            <el-radio-group v-model="failBackConfig.failBackType">
              <el-radio :label="0">不回落</el-radio>
              <el-radio :label="1">回落普通短信</el-radio>
              <el-radio :label="2">回落富信</el-radio>
            </el-radio-group>
            <span style="margin-left: 8px; font-size: 14px; cursor: pointer;color: #7f85e9" >
                    回落说明
                    <el-tooltip 
                      class="item"
                      effect="light"
                      placement="top-start">
                      <div slot="content">
                        温馨提示：<br />
                        由于卡片短信目前只支持全部华为机型和部分的小米机型，其他类型收集无法接收卡片短信<br/>
                        所以建议设置回落短信，设置后指定机型收到的短信为卡片短信，其他手机收到的均为普通短信。
                      </div>
                      <span class="question_icon">!</span>
                    </el-tooltip>
                  </span>
          </el-form-item>
          <el-form-item label="编辑短信:" v-if="formData.smsType == 2 && isMediaQualification  && failBackConfig.failBackType == 1">
            <div class="textarea">
              <el-input class="textareaChange" type="textarea" :rows="5" placeholder="请输入内容" v-model="failBackConfig.content" @paste.native="shopLinkCheck($event, insertCoupon)">
              </el-input>
              <div class="footInfo">
                <div>
                  <button class="select" @click.prevent="templateShow = true">
                    选择模板
                  </button>
                  <button class="keep" @click.prevent="handleShowModule">
                    保存模板
                  </button>
                  <span>已输入
                    <span style="color: #fe4d45">{{ failBackConfig.content.length + (suffixList[0] ? suffixList[0].length : 0) + 8
                    }}</span>
                    个字（含签名及退订文字），预计
                    {{ Math.ceil(sendFailInfoLength > 70 ? sendFailInfoLength / 67 : sendFailInfoLength / 70) }}
                    条短信
                  </span>
                </div>
                <div class="ask-content">
                  <span style="
                          font-weight: normal;
                          margin-left: 8px;
                          color: #7f85e9;
                        ">计费规则</span>
                  <el-tooltip class="item" effect="light" placement="top-start" style="color:#999;">
                    <div v-html="content1" slot="content"></div>
                    <span class="question_icon" style="margin-left: 4px">?</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="footTips" style="height: 180px; position: relative">
              <img src="@/assets/images/new_icon_waring_yellow.png" style="
                      display: inline-block;
                      float: left;
                      position: absolute;
                      width: 14px;
                      height: 14px;
                      color: #ffffff;
                      margin: 0px 4px 0 0;
                      top: 9px;
                    " />
              <span style="margin-left: 22px; line-height: 21px">
                (1) 短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链;
                <br />
                (2) 生成短链后建议复制到手机浏览器打开确保短链接能正常打开。
                <br />
                (3) 包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接 (示例：点击加购x商品详情页> 3.cn/1l-dAxxx)
                <br/> 
                (4) 短网址点击数据由官方返回，部分链接（如含中间页跳转，非原始链接）官方不支持埋点，因此无短网址点击数据
                <br/>
                (5) 原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
              </span>
            </div>
          </el-form-item>
          <el-form-item label="辅助工具:" v-if="formData.smsType == 2 && isMediaQualification  && failBackConfig.failBackType == 1">
            <div class="tool">
              <p @click.prevent="insertShortUrlShow = true"><i class="iconfont iconbtn_duanwangzhi"></i>插入短网址</p>
            </div>
          </el-form-item>
          <el-form-item label="富信模板:" v-if="formData.smsType == 2 && isMediaQualification  && failBackConfig.failBackType == 2">
            <el-select v-model="failBackConfig.mediaTemplateId" @change="changeFailMedia"  filterable>
                <el-option v-for="(item, index) in mediaOptionList" :key="index" :value="item.mediaTemplateId"
                  :label="item.name"></el-option>
              </el-select>
              <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addMediaModule">添加模板</span>
          </el-form-item>
          <div v-if="((formData.smsType == 1 ||formData.smsType == 2) && isMediaQualification) || formData.smsType == 0 ">
            <el-form-item label="短信签名:">
              <div class="btnList">
                <div class="btnBox" v-for="(item, index) in suffixList" :key="index">
                  <el-button class="btn" style="width: auto; font-size: 14px" @click="switchSuffix(index)" :style="{
                    color: selectSuffix == item ? globalBG : '',
                    'border-color': selectSuffix == item ? globalBG : '',
                  }">{{ item }}</el-button>
                  <span class="check" :style="{
                    'background-color': selectSuffix == item ? globalBG : '',
                  }">
                    <i class="el-icon-check"></i>
                  </span>
                </div>

                <span @click="goSuffixUrl" style="
                                                              fontsize: 14px;
                                                              cursor: pointer;
                                                              vertical-align: text-bottom;
                                                            " class="replaceButtom">更换</span>
              </div>
            </el-form-item>

            <el-form-item label="辅助工具:" v-if="formData.smsType == 0">
              <div class="tool">
                <p @click.prevent="handleShowShortLink">
                  <!-- <img
                    src="@/assets/images/lianjie.png"
                    style="width: 14px; height: 14px; margin: 0 4px -1px 0"
                  /> -->
                  <i class="iconfont iconbtn_duanwangzhi"></i>
                  插入短网址
                </p>
                <!-- <p @click.prevent="insertCouponShow = true">
                  <i class="el-icon-paperclip" style="fontSize:10px;marginRight:5px;"></i>插入优惠链接
                </p>
                <p @click.prevent="jdJumpLinkShow = true">
                  <i class="el-icon-paperclip" style="fontSize:10px;marginRight:5px;"></i>APP刷新链接
                </p>-->
              </div>
            </el-form-item>
            <el-form-item label="会员过滤:" v-if="
              sendType == '2' ||
              sendType == '3' ||
              sendType == '4' ||
              sendType == '5' ||
              sendType == '15'
            ">
              <!-- <el-checkbox-group v-model="formData.xxx1"> -->
              <el-checkbox v-model="formData.blackFlag" :label="true">
                黑名单
                <span @click.stop="goBlackUrl" class="setting-black">设置黑名单</span>
              </el-checkbox>
              <el-checkbox :label="true" v-if="
                isPreEvaluate &&
                (sendType == 2 || sendType == 3 || sendType == 15)
              " v-model="formData.badReviewFilterSetting">
                给过中差评客户
              </el-checkbox>
              <el-checkbox :label="true" v-if="
                isPreRefund &&
                (sendType == 2 || sendType == 3 || sendType == 15)
              " v-model="formData.refundFilterSetting">
                退过款客户
              </el-checkbox>

              <!-- <el-checkbox :label="2">给过中差评客户</el-checkbox>
              <el-checkbox :label="3">退过款客户</el-checkbox>-->
              <!-- </el-checkbox-group> -->
            </el-form-item>
            <el-form-item label="短信过滤:" v-if="
              sendType == '2' ||
              sendType == '3' ||
              sendType == '4' ||
              sendType == '5' ||
              sendType == '15'
            ">
              <el-radio-group v-model="formData.fitlerDay">
                <el-radio label>不过滤</el-radio>
                <el-radio :label="3">3天</el-radio>
                <el-radio :label="5">5天</el-radio>
                <el-radio :label="7">7天</el-radio>
                <el-radio :label="15">15天</el-radio>
                <el-radio :label="-1">
                  <el-input style="width: 68px; margin-right: 8px" v-model="formData.fitlerDayNum"></el-input>天内发送过的客户
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号段:" v-if="sendType == '4' || sendType == '5'">
              <el-checkbox :label="-1" v-model="formData.allMobile" @change="handleAllMobile">不限</el-checkbox>
              <el-checkbox-group v-model="formData.mobileTypes" @change="handleSelectMobile"
                style="display: inline-block; margin-left: 20px">
                <el-checkbox :label="1">移动</el-checkbox>
                <el-checkbox :label="2">联通</el-checkbox>
                <el-checkbox :label="3">电信</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="发送人数:" v-if="sendType == '1'">
              <div>
                <el-radio-group v-model="formData.sendIntType" @change="handleSendType">
                  <el-radio :label="0">不限</el-radio>
                  <el-radio :label="1">限制发送数</el-radio>
                </el-radio-group>
                <el-input v-model="formData.sendOutIpt" placeholder="填写发送数" style="width: 120px; margin-left: 8px"
                  :disabled="formData.sendIntType === 0" @keyup.native="
                    formData.sendOutIpt = oninput(formData.sendOutIpt)
                  " @change="sendPeopleChange"></el-input>
              </div>
            </el-form-item>

            <el-form-item label="短信测试:">
              <div class="test" v-if="formData.smsType == 0">
                <!-- <el-input v-model="mobiles" placeholder="输入测试号码" class="ipt" style="width: 220px"
                  @input="phoneTest"></el-input> -->
                <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择"
                  style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                  <el-option v-for="item in testOptions" :key="item" :label="item"
                    :value="item"></el-option>
                </el-select>
                <el-button class="sendTest" @click="handleShowSendTip">发送短信测试</el-button>
                <el-button class="record" @click.prevent="smsDialogs = true">短信记录</el-button>
                <el-button class="record" style="width: auto;padding-left:4px;padding-right:4px;" @click.prevent="updataPhone">修改测试手机号</el-button>
              </div>
              <div class="test" v-else>
                <!-- 需开启富信测试后才可选择测试手机号 -->
                <!-- <el-checkbox v-model="isRichSmsTest" style="margin-right: 10px;z-index: 0;">富信测试</el-checkbox> -->
                <el-select v-model="mediaTestMobilesList" multiple collapse-tags placeholder="请选择"
                  style="width: 264px;vertical-align: top;" @change="selectMediaTestMobiles">
                  <el-option v-for="item in testOptions" :key="item" :label="item"
                    :value="item"></el-option>
                </el-select>
                <el-button style="margin-left: 8px;" class="record1" @click="sendRichTest">发送测试短信</el-button>
                  <el-button class="record" style="margin-right: 0px;" @click="smsDialogs = true">短信记录</el-button>
                  <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="updataPhone">修改测试手机号</span>
              </div>
              <div class="info" v-if="formData.smsType == 1 || formData.smsType == 2">
                <i class="el-icon-warning warning-icon"></i>
                <p>注：短信测试号码为申请签名时报备的号码,且发送测试短信不受频控限制。</p>
                <!-- <p style="color: #FE4D45;">2.官方富信测试规则：富信测试短信和正式短信 一起创建，当运营商审核通过后
                  ，测试短信会立即发出，等到设置的发送时间就发正式短信。如收到测试短信不正常，可以选择取消正式发送的批次任务。</p> -->
              </div>
            </el-form-item>

            <el-form-item label="发送时间:" v-if="
              sendType == '1' ||
              sendType == '2' ||
              sendType == '3' ||
              sendType == '15'
            ">
              <div>
                <!-- <el-date-picker
                    v-model="formData.sendTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    :picker-options="expireTimeOption"
                    @change="handleTime">
                </el-date-picker>-->

                <el-date-picker v-model="formData.sendTime1" type="date" class="pickerChange" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="expireTimeOption1" style="width: 136px"
                  @change="dateChange"></el-date-picker>

                <el-time-picker v-model="formData.sendTime2" format="HH:mm:ss" class="pickerChange1" value-format="HH:mm:ss"
                  :picker-options="expireTimeOption2" placeholder="选择时间" style="margin-left: 8px; width: 136px"
                  @change="timeChange"></el-time-picker>
              </div>
            </el-form-item>
            <!-- <festivals></festivals> -->
            <el-form-item label="发送类型:" v-if="sendType == '4' || sendType == '5'">
              <el-radio-group v-model="formData.mySendType">
                <el-radio :label="0">立即发送</el-radio>
                <el-radio :label="1">定时发送</el-radio>
                <el-date-picker v-if="formData.mySendType == 1" v-model="formData.sendTime1" type="date"
                  class="pickerChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"
                  :picker-options="expireTimeOption1" style="width: 136px" @change="timeChangeOne"></el-date-picker>

                <el-time-picker v-model="formData.sendTime2" v-if="formData.mySendType == 1" format="HH:mm:ss"
                  class="pickerChange1" value-format="HH:mm:ss" placeholder="选择时间" style="margin-left: 8px; width: 136px"
                  @change="timeChangeOne"></el-time-picker>
              </el-radio-group>

              <div class="footTips" v-if="smsType == 3">
                <img src="@/assets/images/new_icon_waring_yellow.png" style="
                                                              display: inline-block;
                                                              float: left;
                                                              position: absolute;
                                                              width: 14px;
                                                              height: 14px;
                                                              color: #ffffff;
                                                              margin: 0px 4px 0 3px;
                                                            " />
                <span style="margin-left: 24px">
                  短信发送时间为7：00-22：00，非时间段内发送短信第二天发送</span>

                <!-- <span style="margin-left: 24px;">
                  5月26日-6月18日短信发送时间为00:00-23:59:59</span
                > -->
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div v-if="
          sendType == '1' ||
          sendType == '2' ||
          sendType == '3' ||
          sendType == '15'
        " class="activityTip">
          {{ globalActivityTip }}
        </div>

        <!-- 短信预览效果 -->
        <div class="xiao-hug xiao_hug2" v-if="formData.smsType == 0">
          <div style="margin: 0 auto; width: 256px">
            <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
              <div class="message-content" style>
                【{{ formData.jdSmsSuffix }}】{{ formData.content }}{{ TTip }}
              </div>
            </div>
            <div class="mobile-tips">短信预览效果</div>
          </div>
        </div>
        <div class="xiao-hug xiao_hug2" v-if="formData.smsType == 1">
          <div>
            <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">  
              <sms-info-body v-if="mediaId && preMediaShow" :key="mediaId" :title="smsInfoRowData.title" :text="smsInfoRowData.text" :mediaListJsonArray="smsInfoRowData.mediaList"></sms-info-body>
            </div>
            <div class="mobile-tips">富信预览效果</div>
          </div>
        </div>
        <div class="xiao-hug xiao_hug2" v-if="formData.smsType == 2">
            <div>
              <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">  
                <sms-info-card-body v-if="cardId && preCardShow" :key="mediaTemplateId" :id="mediaTemplateId" ></sms-info-card-body>
              </div>
              <div class="mobile-tips">卡片预览效果</div>
            </div>
          </div>
      </div>

      <!-- 底部发送 -->
      <div v-if="((formData.smsType == 1|| formData.smsType == 2) && isMediaQualification) || formData.smsType == 0 ">
      <footer class="foot" v-if="sendStep == 2">
        <el-button v-if="sendType == '1'" type="primary" @click="handleSaveDraft">保存草稿</el-button>
        <el-button v-if="sendType == '1'" class="sendTest" @click="handleClearEmpty"
          style="margin-right: 10px; border: 1px solid #fe4d45; color: #fe4d45">一键清空</el-button>
        <p class="txt" v-if="formData.smsType == 0">
          共筛选出
          <span :style="{ color: globalBG }">{{ sendPeopleNum }}</span>
          会员，预计消耗短信
          <span :style="{ color: globalBG }">{{
            sendPeopleNum *
            Math.ceil(
              sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
            )
          }}</span>
          条
          (当前短信余额
          <span class="num" :style="{ color: globalBG }">{{ balance }}</span>
          条)
        </p>
        <p class="txt" v-if="formData.smsType == 1">
          共筛选出
          <span :style="{ color: globalBG }">{{ sendPeopleNum }}</span>
          会员，预计消耗短信
          <span :style="{ color: globalBG }">{{
            fxSmsUseNum
          }}</span>
          条，
          (当前富信余额
          <span class="num" :style="{ color: globalBG }">{{ fuxinSms }}</span>
          条)
        </p>
        <p class="txt" v-if="formData.smsType == 2">
          共筛选出
          <span :style="{ color: globalBG }">{{ sendPeopleNum }}</span>
          会员，预计消耗短信
          <span :style="{ color: globalBG }">{{
            fxSmsUseNum
          }}</span>
          条，
          (当前卡片短信余额
          <span class="num" :style="{ color: globalBG }">{{
              this.$store.getters.loginUserInfo.payCardSmsTotal -
                this.$store.getters.loginUserInfo.useCardSmsTotal || "--"
              }}</span>
          条)
        </p>
        <el-button class="btn" @click="lastStep" v-if="sendType == 2 && !isEffectSend">返回上一步</el-button>

        <el-button class="btn" type="primary" @click="handleSend">提交发送</el-button>
      </footer>
      </div>
    </div>

    <!-- 选择人群 -->
    <select-people :peopleList="showSelectPeople" v-if="selectPeopleDialog" @onConfirm="handleSelectPeople"
      @onCancle="canclePeople" :selectPeopleDialog="selectPeopleDialog"></select-people>

    <!-- 选择模板 -->
    <sms-template v-if="templateShow" :isShow="templateShow" @close="templateChange"></sms-template>

    <!-- 保存模板 -->
    <my-popup title="保存模板" width="370" :zIndex="'3330'" :flag="keepTmpShow" @close="keepTmpChange">
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select v-model="keepTmpValue" placeholder="请选择" style="width: 240px">
            <el-option v-for="(item, index) in dirList" :key="index" :label="item.title" :value="item.tid"></el-option>
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 插入短链接 -->
    <insert-short-dialog v-if="insertShortUrlShow" :typeSms="smsType" :strategyInstId="computeData.strategyInstId"
      @close="handleCloseShort"></insert-short-dialog>
    <!-- <my-popup title="插入短链接网址" width="582" :flag="insertShortUrlShow" @close="insertUrlChange">
      <div class="insertBox">
        <div class="inser">
          <span>网址：</span>
          <el-input v-model="insertUrlValue" placeholder="仅支持手机端京东域名链接，如m.jd" style="width: 480px;"></el-input>
        </div>
        <div class="tip_box">
          <div>注：（1）仅支持手机端京东域名链接，如m.jd，且短信中只能插入一条短链；</div>
          <div style="padding-left: 24px;">（2）发送测试短信不受发送时间限制，点击发送后，测试短信立即发送</div>
        </div>
        <button class="createUrlBtn" @click="insertUrlChange(1)">生成网址</button>
      </div>
    </my-popup>-->

    <!-- 插入优惠券链接 -->
    <!-- <insert-coupon-link
      v-if="insertCouponShow"
      :isShow="insertCouponShow"
      @close="insertCouponChange"
    ></insert-coupon-link>-->

    <!-- App跳转链接 -->
    <my-popup width="582" title="京东跳转APP链接" :flag="jdJumpLinkShow" @close="jdJumpLinkChange">
      <div class="jumpLinkBox">
        <div class="item">
          <label>链接类型：</label>
          <el-select v-model="jumpLinkSelectValue" placeholder="请选择" style="width: 452px">
            <!-- <el-option label="全部" :value="0"></el-option>
                    <el-option label="一半" :value="1"></el-option>
            <el-option label="没有" :value="2"></el-option>-->
            <el-option label="店铺首页" :value="0"></el-option>
            <el-option label="商品详情页链接" :value="1"></el-option>
            <el-option label="其它页面" :value="2"></el-option>
          </el-select>
        </div>
        <div class="item">
          <label>链接：</label>
          <el-input v-model="jumpLinkIptValue" placeholder="请输入....jd" style="width: 452px"></el-input>
        </div>
        <div class="create">
          <button class="createBtn" @click="jdJumpLinkChange(1)">
            生成网址
          </button>
        </div>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <sms-template2 :smsDialog="smsDialogs" :isCard="formData.smsType == 2" :isMedia="formData.smsType == 1" v-if="smsDialogs" @transferName="transferName"
      @close="smsDialogClose"></sms-template2>
    <!--导入手机号弹窗 -->
    <import-phone-dialog v-if="showPhoneDialog" :visible="showPhoneDialog"
      @onClose="handleImportPhone"></import-phone-dialog>

    <!-- 发送确认弹窗 -->
    <el-dialog :visible.sync="showSendConfirm" title="发送确认" width="450px" custom-class="send-con-dialog">
      <div v-if="formData.smsType == 0">
        <span v-if="isTestSend">提交号码为 {{ phoneLenght }}</span>
        <!-- <div> -->
        <span v-if="!isTestSend">
          发送人数：
          <span :style="{ color: globalBG }">{{
            formData.sendIntType == "1" ? formData.sendOutIpt : sendPeopleNum
          }}</span>人
        </span>
        <!-- </div> -->
        ，当前短信字数为
        <span :style="{ color: globalBG }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: globalBG }">{{
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条计费，提交
        <span :style="{ color: globalBG }">{{
          isTestSend
          ? phoneLenght *
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
          : (formData.sendIntType == "1"
            ? formData.sendOutIpt
            : sendPeopleNum) *
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div v-else-if="formData.smsType == 1" style="line-height: 30px;">
        <div>
          <span v-if="!isTestSend">
            发送人数：
            <span :style="{ color: globalBG }">{{fxSmsUseNum}}</span>人
          </span>
        </div>
        <div>
          富信内容：{{ formData.mediaTitle }}
        </div>
        <div>
          富信大小：<span :style="{ color: globalBG }">{{richMessageData.totalSize}}M</span>
        </div>
        <div>
          富信计费条数：<span :style="{ color: globalBG }">1</span>条
        </div>
        <div>
          提交条数：<span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>条
        </div>
      </div>
      <div v-else-if="formData.smsType == 2" style="line-height: 30px;text-align: left;">
          <div>
            <span v-if="!isTestSend">
              发送人数：
              <span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>人
            </span>
          </div>
          <div>
            卡片短信内容：{{ cardName }}
          </div>
          <div>
            卡片短信计费条数：<span :style="{ color: globalBG }">1</span>条
          </div>
          <div>
            提交条数：<span :style="{ color: globalBG }">{{ fxSmsUseNum }}</span>条
          </div>
        </div>
      <div class="btn-group">
        <el-button @click="showSendConfirm = false">取消</el-button>
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
      </div>
    </el-dialog>

    <!-- 发送成功提示 -->
    <el-dialog :visible.sync="successDialog" title="提示" width="400px" append-to-body custom-class="send-con-dialog">
      <div class="success-tip">
        <img src="@/assets/images/tip_success.png" />
        <span>亲，短信已经成功提交了哦！</span>
      </div>
      <div class="btn-group">
        <el-button @click="handleViewRecord">查看记录</el-button>
        <el-button type="primary" @click="handleConSending">继续发送</el-button>
      </div>
    </el-dialog>

    <!-- 去设置弹层 -->
    <SetDialog :visible="setDialogVisible" @close="setDialogVisible = false"></SetDialog>
    <!-- 修改测试手机号弹窗 -->
    <el-dialog title="修改测试短信号码" :visible.sync="showDialogOne" width="460px" style="min-width: 1100px">
      <template slot="title">
        <span>修改短信号码</span>
      </template>
      <div class="dialog-wrapper">
        <!-- <div class="item">
          <span class="item-title">短信测试：</span>
          <el-input size="small" class="input" v-model="testMobiles"></el-input>
        </div> -->
        <div class="remarks">
          <div>请前往【京东云舟】-【工具】-【短信工具】-【短信签名】中进行修改号码中操作</div>
          <!-- <img class="img" src="@/assets/images/new_icon_waring.png" /> -->
          <!-- <span>注：填写测试号码，在测试发送时无需审核短信内容。</span> -->
          <!-- <div>1、测试短信手机号不受频控限制，最多填写15个，多个之间用英文逗号分隔；</div>
          <div>2、修改完成后立即生效，且测试手机号的修改会应用到全部渠道；</div>
          <div>3、每天修改手机号的次数上限为5次；</div> -->
        </div>
        <div></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">关闭</el-button>
        <!-- <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">取消</el-button>
        <el-button @click="mobilPhoneSubmit" type="primary" style="width: 96px">提交</el-button> -->
      </span>
    </el-dialog>
    <!-- 富信选择模板 -->
    <myPopup title="选择模板" :flag="selectTempleteShowDialog" :zIndex="'4000'" :width="'800'" @close="chooseTemplate(null,1)" style="margin-top: -50px;">
      <div class="selectTemplet">
        <el-table v-loading="tableLoading" :data="selectTemplateData" style="width: 100%;border: 1px solid #e6e6e6;text-align: center;">
          <el-table-column prop="name" label="模板名称"></el-table-column>
          <el-table-column label="模板内容">
            <template slot-scope="scope">
              <span style="color: #7f85e9;cursor: pointer;" @click="showTemplateInfo(scope.row)">{{ scope.row.title
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="最后一次修改时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span style="color: #FE4D45;cursor: pointer;" @click="chooseTemplate(scope.row)">选择</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: right;margin-top: 28px;">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleTemplateCurrentChange" 
        :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="templatePaginationInfo.total"
        :page-size="templatePaginationInfo.size" :current-page="templatePaginationInfo.current" 
        style="text-align: right; margin-top: 20px;">
        </el-pagination>
      </div>
    </myPopup>
    <!-- 富信保存模板 -->
    <myPopup title="保存模板" :flag="richkeepTmpShow" :zIndex="'0'" @close="handleCloseTmp">
      <div class="selectBox1">
        <div class="headCnt">
          <span><span style="color:red;">*</span> 模板名称：</span>
          <el-input v-model="richtemplateName" style="width: 350px;" maxlength="15" show-word-limit>
          </el-input>
        </div>
        <el-button @click="handleCloseTmp(1)">保存模板</el-button>
      </div>
    </myPopup>
    <sendTestMediaConfirm 
      v-if="sendTestMediaConfirmShow"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="sendTestMediaConfirmShow = false"
      :source="2"
      :mediaTestMobilesList="mediaTestMobilesList"
      :id="mediaId"
      :mediaTemplateId="mediaTemplateId">
    </sendTestMediaConfirm>
    <sendTestCardConfirm 
      v-if="sendTestCardConfirmShow"
      @close="sendTestCardConfirmShow = false" 
      @confirm="sendTestCardConfirmShow = false"
      :source="2"
      :mediaTestMobilesList="mediaTestMobilesList"
      :title="cardName"
      :mediaTemplateId="mediaTemplateId">
    </sendTestCardConfirm>
    <!-- 短信内容预览 -->
    <sms-info v-if="smsInfoShow" @close="handleCloseSmsInfo" :isShow="smsInfoShow" :id="smsInfoRowData.contentId" :title="smsInfoRowData.title" :text="smsInfoRowData.text" />
  </div>
</template>
<script>
// import {
//   addBlackList,
// } from "@/api/backList";
import sendTestMediaConfirm from './sendTestMediaConfirm';
import sendTestCardConfirm from './sendTestCardConfirm';
import { getSeller } from "@/api/richSms";
import { getLabel } from "@/api/uploadFile";
import { saveDraft, getDraft,postSmsType } from "@/api/marketing/precisionMarketing";
import { getTemplateDir, createTemplate, getSmsMediaTemplate, getSmsMediaTemplateDetail,smsMediaTemplateSave } from "@/api/smsTemplates";
import { caculateMember } from "@/api/memberLabel";
import { packStatus } from "@/api/memberCrowd";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { getSellerInfo,getShopInfo } from "@/api/sellerController";
import {
  preCommit,
  NewPreCommit,
  precisionMarketing,
  platformSend,
  getSendTime,
  crowdCount,
  getValidSmsTestMobiles,
  mediaDetail,
  getMediaList,
  getCardList
} from "@/api/smsSend";
import { updateSuffixMobileById } from "@/api/backstage/messageBill";
import { getMemberCrowd } from "@/api/marketing/precisionMarketing";
import { mapState } from "vuex";
import topTitle from "@/components/top-title.vue";
import smsTemplate from "@/views/serviceCenter/sms_template";
import myPopup from "@/components/myPopup";
import insertCouponLink from "@/views/serviceCenter/insert_coupon_link";
// import smsTemplate2 from "@/views/care/chidrenCare/sms-templates.vue";
import smsTemplate2 from "@/components/sms-templates-x-drawer.vue";
import selectPeople from "@/components/select-people.vue";
import insertShortDialog from "@/components/insert-short-dialog";
import importPhoneDialog from "@/components/import-phone-dialog";
import SetDialog from "@/components/SetDialog";
// 富信组件
import richMessage from "@/components/rich-message";
import smsInfo from "@/components/sms-info";
import smsInfoTemplate from "@/components/sms-info-template";
import smsInfoBody from "@/components/sms-info-body";
import smsInfoCardBody from "@/components/sms-info-card-body";


export default {
  name: "sendMessageX",
  components: {
    topTitle,
    smsTemplate,
    myPopup,
    insertCouponLink,
    smsTemplate2,
    selectPeople,
    insertShortDialog,
    importPhoneDialog,
    SetDialog,
    richMessage,
    smsInfo,
    smsInfoBody,
    smsInfoTemplate,
    sendTestMediaConfirm,
    sendTestCardConfirm,
    smsInfoCardBody
  },
  props: {
    sendType: {
      type: Number,
      default: 1, // 1.表示精选营销的发送短信，分两部分发送的 2.表示会员发送的发送短信 3.订单号码发送页面的发送短信 4.指定号码发送 5.变量短信发送 6.营销官方 （首购有礼） 15 预售订单发送
    },
    conditionParam: {
      // 会员发送的预发送条件查询
      type: Object,
      default: () => { },
    },
    conditionNum: {
      // 会员发送带过来的选择会员数
      type: Number,
      default: 0,
    },
    preSendType: {
      // 测试短信的预提交类型 1 按条件查询 2 勾选 3 按会员分组 0 其他
      type: Number,
      default: 0,
    },
    orderIds: {
      // 订单发送勾选时，传的订单id
      type: Array,
      default: () => [],
    },
    precisionMData: {
      // 精准营销数据回显
      type: Object,
      default: () => { },
    },
    reSendSmsObj: {
      // 再次发送的发送信息回显
      type: Object,
      default: () => { },
    },

    uploadAgainDB: {
      type: Object,
      default: () => { },
      // 指定号码发送上传手机号码, 变量短信发送
      // totalMobile fid content
    },
    effectParam: {
      type: Object,
      default: () => { }, // 效果分析的参数
    },
    signature: {
      type: Number,
      default: 0, // 效果分析的参数
    },
    editItem: {
      type: Object,
      default: () => { }, // 编辑回显
    },
    isOlderSent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Selectmobiles:[],
      cardName:'',
      preCardShow:false,
      sendTestCardConfirmShow:false,
      cardId:null,
      cardOptionList:[],
      // 回落数据
      failBackConfig:{
        failBackType:0,
        content:'',
        jdShortLink:'',
        realUrl:'',
        mediaTemplateId:'',
        mediaMulitiFileId:'',
      },
      editLoading: true,
      preMediaShow:false,
      smsInfoTemplateShow:false,
      sendTestMediaConfirmShow:false,
      isMediaQualification:false,
      mediaId:null,
      mediaTemplateId:null,
      mediaOptionList:[],
      isEdit:false,//true为修改状态，false为新建状态
      editId:'',//草稿ID
      sourceUrl: "", // 短链接 原链接
      isPremissionShow: false, // 屏蔽近X天发送客户的权限
      preLoading: false,
      setDialogVisible: false,
      smsDialogs: false,
      successDialog: false,
      smsType: 1, // 短信类型，1.精准营销 2.官方发送 3.系统平台
      /** 选择人群相关参数 */
      showSelectPeople: [],
      includePeople: [],
      excludePeople: [], // 排除人群
      peopleType: 0, // 0.表示 选择人群 1.表示排除人群
      includeRule: 1,
      excludeRule: 1, // 删除人群运算规则1.合并 0.交集
      isExcludeFlag: false, // 是否勾选排除人群
      blacklisted: false, // 是否勾选黑名单列表
      filterAlreadySentFlag: false, // 是否勾选过滤几天已发送的客户
      filterDays: "", // 过滤多少天
      /** end  */

      showPhoneDialog: false,
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      nodata: require("@/assets/images/nodata.png"),
      expireTimeOption2: {
        selectableRange: "9:00:00 - 19:55:59",
      },
      limitTime: {},
      expireTimeOption3: {
        selectableRange: "7:00:00 - 19:55:59",
      },
      expireTimeOption1: {
        disabledDate(date) {
          return (
            date.getTime() < Date.now() - 8.64e7 ||
            date.getTime() > Date.now() + 8.64e7 * 90
          );
        },
      },
      // expireTimeOption: {
      //   selectableRange: '9:00:00 - 19:55:59',
      //   disabledDate(date) {
      //           return date.getTime() < Date.now()- 8.64e7;
      //           // return time.getTime() < Date.now()-1 * 24 * 3600 * 1000
      //   }
      // },
      keepTmpValue: "",
      selectTemplate: {}, // 选择的模板

      selCrowdName: "",

      tableLoading: false,
      selectPeopleDialog: false,
      // SuffixName: "云短信旗舰店",
      // 表单数据
      formDataX: {
        filterCondition: [],
      },
      formData: {
        /** 官方发送参数 */
        activityTitle: "", // 活动主题
        content: "",
        jdShortLink: "",
        url: "", // 原始地址（非精准营销的短链接的原始地址）
        jdSmsSuffix: "", // 短信签名
        sendSubmitNum: "", // 短信发送提交人数
        sendSubmitNumType: 0, // 0不限（官方） 填入买家余额 1人群包人数
        sendTime: "", //  发送时间 格式 yyyy-MM-dd HH:mm:ss
        // strategyInstId: '', // 实例化id
        /*** 官方参数 end */
        sendTime1: "", // yyyy-MM-dd
        sendTime2: "", // HH:mm:ss
        sendOutIpt: null, // 发送人数
        fitlerDay: "",
        fitlerDayNum: "", // 自定义输入人数
        blackFlag: true, // 黑名单
        mobileTypes: [], // 手机号段
        allMobile: true, // 不限
        jmlIds: [], // 悦信短网址链接id列表

        inputMobileStr: "", // 输入手机号
        sendIntType: 0,
        type: 1, // 指定号码发送-发送对象 1. 表示输入手机号码 2.表示上传手机号码
        mySendType: 0, // 0.立即发送 1.定时发送
        smsType: 0, // 短信类型 0普通短信，1富信
        mediaTestMobiles: '', // 富信测试手机号
        mediaTitle: '', // 富信标题
        mediaList: [], // 富媒体列表
        // isJoin: false,
      },
      // sendOutIpt: null,
      templateShow: false, // 短信模板状态控制
      keepTmpShow: false, // 保存模板状态控制 ---- 内容
      insertShortUrlShow: false, // 插入短链接状态控制 ----- 内容
      insertUrlValue: null,
      // insertCouponShow: false, // 插入优惠券链接控制
      jdJumpLinkShow: false, // 京东跳转App链接控制 ---- 内容
      jumpLinkSelectValue: 0,
      jumpLinkIptValue: null,
      smsState2: false,

      sendStep: 2, // 2.编辑短信  // 步骤栏取消了，现在默认是2
      // insertShortUrl: '', // 插入的短链接

      selectSuffix: "", // 当前选中的签名
      suffixList: [],
      balance: "", // 短信余额
      mobiles: "", // 测试发送的手机号
      sendPeopleNum: 0, // 筛选的会员数
      computeLoading: false, // 计算人群loading
      crowdStatus: false, // 人群包状态

      computeData: {
        // 计算人群数量
        count: 0,
        strategyInstId: "", // 人群测试id
      },
      requestNum: 20, // 挖宝重复请求次数

      preData: {
        // 预提交返回的数据
        sendObjectCount: 0,
        sendObjectId: "",
      },
      preTestData: {
        sendObjectCount: 0,
        sendObjectId: "",
      },

      showSendConfirm: false, // 短信发送确认弹窗
      // strLenght: 0,
      phoneLenght: 0, // 提交号码数量
      isTestSend: false, // 是否为测试短信的发送，用于发送确认框
      TTip: "拒收请回复R",
      uploadObj: { totalMobile: 0 }, // 上传文件返回的参数 totalMobile fid

      dirList: [],
      jdShortLinkList: [], // 京东短链接映射
      isEffectSend: false, // 是否为营销效果分析跳转过来的发送
      effectRadio: "",
      effectRadioList: [],
      variableList: [],
      isPreRefund: false, // 过滤退过款
      isPreEvaluate: false, // 过滤给过中差评客户
      richMessageData: {isMediaQualification: false}, // 富信组件传递的参数
      isRichSmsTest: false, // 是否启用 富信测试 
      testOptions: [], // 获取测试手机号
      textPhoneId: '', // 修改测试手机号id
      mediaTestMobilesList: [], // 选中的测试手机号列表
      showDialogOne: false, // 修改测试手机号弹窗
      mobilPhone: '', // 测试手机号
      testMobiles: '', // 修改测试手机号
      selectTempleteShowDialog: false, // 富信选择模板
      richkeepTmpShow: false, // 富信保存模块弹窗
      smsInfoShow: false, // 短信预览弹窗
      smsInfoRowData: {}, // 短信详情数据
      selectTemplateData: [],// 选择模板
      mediaTemplateForm: {  // 富信选择模板列表查询
        size: 10,
        current: 1
      },
      templatePaginationInfo: {  // 选择模板分页器
        current: 1,
        size: 10,
        total: 2
      },
      richtemplateName: '', // 富信保存模板名称
      returnData:{
        totalSize: 0, // 总大小
        mediaTitle: "", // 短信标题
        content: '', // 文本内容
        mediaList: [], // 富媒体列表
        jdSmsSuffix: '', // 短信签名
        sourceUrl: '' // 原链接
      }, // 富信回显
      fuxinSms: 0, // 富信余额
      PuTongDate:{},
      FuXinDate:{},
      KaPianDate:{}
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      globalActivityTip: "globalActivityTip",
      //   把city映射给currentCIty
    }),
    content1() {
      return (
        "<div>1.70个字计1条短信，超过70字按照67字每条计费。</div>" +
        "<div>2.一个汉字，字母或标点空格都算作一个字。</div>" +
        '<div>3.带标签短信以实际发送为准，有可能超过默认字数。</div>' +
        '<div>4."签名"与"拒收请回复R"包含在字数中。</div>' +
        '<div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>' +
        '<div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>'
      );
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    sendInfoLength() {
      return (
        this.formData.content.length +
        this.formData.jdSmsSuffix.length +
        2 +
        this.TTip.length
      );
      // if (this.formData.content) {
      //   return this.formData.content.length + this.formData.jdSmsSuffix.length + 2 + this.TTip.length; // 2.表示 【】
      // } else {
      //   return 0;
      // }
    },
    sendFailInfoLength() {
      try {
        if (this.failBackConfig.content) {
          return this.failBackConfig.content.length + this.formData.jdSmsSuffix.length + 2 + this.TTip.length;
        } else {
          return 0;
        }
      } catch (e) {
        return 0;
      }
    },
    // 富信预计消耗条数
    fxSmsUseNum(){
      // 不限制发送人数
      if(this.formData.sendIntType == 0){
        return this.sendPeopleNum 
      }else{
        // 限制发送人数
        if(this.sendPeopleNum > this.formData.sendOutIpt){
          return Number(this.formData.sendOutIpt) 
        }else{
          return this.sendPeopleNum 
        }
      }
    },
  },
  watch: {
    editItem(nVal, oVal){
      console.log(nVal,"新")
      this.hanleEditItem(nVal)
    },
    permissions(nVal, oVal) {
      if (nVal.indexOf("hide:filter:send") != "-1") {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
      if (nVal.indexOf("hide:filter:refund") != "-1") {
        this.isPreRefund = true;
      }
      if (nVal.indexOf("hide:filter:evaluate") != "-1") {
        this.isPreEvaluate = true;
      }
    },
    precisionMData(nVal, oVal) {
      this.init();
    },
    uploadAgainDB(nVal, oVal) {
      this.init();
    },
    isExcludeFlag(nVal, oVal) {
      this.sendPeopleNum = 0;
    },
    includePeople() {
      this.sendPeopleNum = 0;
    },
    excludePeople() {
      this.sendPeopleNum = 0;
    },
    includeRule() {
      this.sendPeopleNum = 0;
    },
    excludeRule() {
      this.sendPeopleNum = 0;
    },
    // 监听是否勾选富信测试
    isRichSmsTest() {
      if (!this.isRichSmsTest) {
        this.formData.mediaTestMobiles = ''
        this.mediaTestMobilesList = []
      }
    },
    'formData.smsType':{
      handler(nVal){
        console.log('短信类型',nVal);
        if(this.sendType == 1 && !this.$route.query.to){
          this.handleSmsType(nVal)
        }
        if(nVal == 0){
          this.clearBuriedPoint()
        }else if(nVal == 1){
          let name = ''
          if(this.sendType == 1) name = '精准营销/富信';
          if(this.sendType == 2) name = '会员发送/富信';
          if(this.sendType == 3) name = '订单发送/富信';
          if(this.sendType == 15) name = '预售订单发送/富信';
          this.buriedPoint(2, name, "客户营销", "精准营销")
        }else{
          let name = ''
          if(this.sendType == 1) name = '精准营销/卡片短信';
          if(this.sendType == 2) name = '会员发送/卡片短信';
          if(this.sendType == 3) name = '订单发送/卡片短信';
          if(this.sendType == 15) name = '预售订单发送/卡片短信';
          this.buriedPoint(2, name, "客户营销", "精准营销")
        }
      },
      immediate: true,
    }
  },
  mounted() {
    this.formData.theme = "精准营销" + this.getNowDate(); // 活动主题
    this.getSmsBalance(); // 获取短信余额
    this.init();
    this.getOfficialSuffix();
    this.limitSendTime();
    //从商品分析跳转过来
    console.log(this.$route.query.id == 78);
    if (this.$route.query.id == 78) {
      this.formData.inputMobileStr = window.localStorage.getItem("mobile");
    }
    // 会员分析营销
    if (this.$route.query.to == "grouping") {
      if (window.localStorage.getItem("strategy")) {
        console.log(JSON.parse(window.localStorage.getItem("strategy")));
        this.includePeople[0] = JSON.parse(
          window.localStorage.getItem("strategy")
        );
        // window.localStorage.removeItem("strategy");
      }
    }

    if (this.$route.query.preId) {
      // this.sendStep = 2;
      this.includePeople[0] = JSON.parse(
        window.localStorage.getItem("strategy")
      );
    }

    if (this.$route.query.precisionCrowdStrategyId) {
        var param = {
          current: 1,
          size: 10,
          name:'',
          type:10,
          description:'',
          precisionCrowdStrategyId:this.$route.query.precisionCrowdStrategyId
        };
        getMemberCrowd(param).then((res)=>{
          console.log("从行业人群跳过来111",res)
          this.includePeople = res.data.records
        })
    }

    // 获取测试手机号
    getValidSmsTestMobiles().then(res=>{
      if(res.code == 1){
        this.testOptions = res.data.smsTestMobiles
        this.testMobiles = res.data.smsTestMobiles.join(',')
        this.textPhoneId = res.data.id
      }
    })
    this.editLoading = true;
    getSeller().then(res => {
      this.editLoading = false;
      if (res.code == 1) {
        this.isMediaQualification = res.data.isMediaQualification
        if(this.isMediaQualification){
          this.getMediaOption('');
          this.getCardOption('');
        }
      }
    }).catch(err =>{
      this.editLoading = false;
    })
    this.fuxinSms = sessionStorage.getItem('fuxin')
    console.log(this.sendType);
  },
  beforeDestroy() {
    window.localStorage.removeItem("mobile");
  },
  methods: {
    getVal() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res=>{
        if(res.code == 1){
          this.testOptions = res.data.smsTestMobiles
          this.testMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    addCardModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "6" },
      });
      window.open(routeUrl.href, "_blank");
    },
    getCardOption(name){
      getCardList({name}).then(res=>{
        if(res.code == 1){
          this.cardOptionList = res.data
          if(this.cardId2 && this.sendType == 1){
            
            let row = this.cardOptionList.find(o=>o.mediaTemplateId == this.cardId2)
            this.cardId = row.id
            this.changeCard();
          }
          
        }else{
          this.$message.error(res.message)
        }
      })
    },
    changeCard(){
      let row = this.cardOptionList.find(o=>o.id == this.cardId)
      this.mediaTemplateId = row.mediaTemplateId
      this.formData.content = row.text;
      this.formData.mediaTitle = row.title;
      this.cardName = row.title;
      console.log('formData',this.formData);
      this.preCardShow = true;
    },
    changeFailMedia(){
      let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.failBackConfig.mediaTemplateId)
      getSmsMediaTemplateDetail(row.id).then(res=>{
        let data = res.data
        this.failBackConfig.content = data.text
        this.failBackConfig.jdShortLink = data.jdShortLink
        this.failBackConfig.realUrl = data.originUrl
        this.failBackConfig.mediaMulitiFileId = data.mediaMulitiFileId
      })
    },
    // 查看富信营销案例
    checkOut() {
      this.smsInfoTemplateShow = true
    },
    // 关闭富信营销案例弹窗
    handleCloseSmsInfo1() {
      this.smsInfoTemplateShow = false
    },
    // 提交资质申请开通
    toSubmit() {
      // 跳转至  后台管理-富信资质
      this.$router.push({ name: 'media_qualification' })
    },
    addMediaModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "5" },
      });
      window.open(routeUrl.href, "_blank");
    },
    getMediaOption(name){
      getMediaList({name}).then(res=>{
        if(res.code == 1){
          this.mediaOptionList = res.data
          if(this.mediaId2 && this.sendType == 1){
            let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.mediaId2)
            this.mediaId = row.id
            this.changeMedia();
          }
        }else{
          this.$message.error(res.message)
        }
      })
    },
     // 富信测试
    sendRichTest(){
      if(this.formData.smsType == 1){
        if( !this.mediaId){
          this.$message.warning("请选择富信模板");
          return;
        }
        
        if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
          this.sendTestMediaConfirmShow = true;
        }else{
          this.$message.warning('请输入正确的手机号！');
          return 
        }
      }
      else if(this.formData.smsType == 2){
        if( !this.cardId){
          this.$message.warning("请选择卡片短信模板");
          return;
        }
        if(this.failBackConfig.failBackType == 1 && !this.failBackConfig.content){
          this.$message.warning("请填写回落短信内容");
          return;
        }
        if(this.failBackConfig.failBackType == 2 && !this.failBackConfig.mediaTemplateId){
          this.$message.warning("请选择回落富信模板");
          return;
        }
        if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
          this.sendTestCardConfirmShow = true;
        }else{
          this.$message.warning('请输入正确的手机号！');
          return 
        }
      }
    },
    changeMedia(){
      let row = this.mediaOptionList.find(o=>o.id == this.mediaId)
      this.mediaTemplateId = row.mediaTemplateId
      this.preMediaShow = false;
      if(this.mediaId){

      
        getSmsMediaTemplateDetail(this.mediaId).then(res => {
          if (res.code == 1) {
            let data = res.data
            this.returnData.mediaTitle = data.title
            this.returnData.totalSize = data.totalSize
            this.returnData.content = data.text
            this.returnData.mediaList = data.mediaList
            this.returnData.sourceUrl = data.originUrl
            this.returnData.jdShortLink = data.jdShortLink

            this.richMessageData.mediaTitle = data.title
            this.richMessageData.totalSize = data.totalSize
            this.richMessageData.content = data.text
            this.richMessageData.mediaList = data.mediaList
            this.richMessageData.sourceUrl = data.originUrl
            this.richMessageData.jdShortLink = data.jdShortLink
            this.smsInfoRowData = res.data
            this.preMediaShow = true;
          }
        })
      }
    },
    handleRouter() {
      if (this.signature == 1 || this.signature == 2) {
        let routeUrl = this.$router.resolve({
          path: "/backstage/signature_management/signature_report_official",
        });
        window.open(routeUrl.href, "_blank");
        // this.$router.push({ path: "/backstage/signature_management/signature_report_official" });
        return;
      }
      this.setDialogVisible = true;
    },
    handc(val) {
      // console.log("123", val);
    },
    handleSendType(val) {
      this.formData.sendOutIpt = "";
    },
    limitInput(event) {
      if (event.target.value == "0") {
        event.target.value = "";
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, "");
      }
    },
    // 插入短信变量
    insertContent(myValue) {
      const smsContent = document.querySelector("#smsContent");
      var startPos = smsContent.selectionStart;
      var endPos = smsContent.selectionEnd;
      console.log("startPos:", startPos);

      if (startPos || startPos.selectionStart == "0") {
        smsContent.value =
          smsContent.value.substring(0, startPos) +
          myValue +
          smsContent.value.substring(endPos, smsContent.value.length);
        smsContent.selectionStart = startPos + myValue.length;
        smsContent.selectionEnd = startPos + myValue.length;
        smsContent.focus();
      } else {
        smsContent.value += myValue;
        smsContent.focus();
      }
      this.formData.content = smsContent.value;
    },
    goBack() {
      this.$emit("goBack");
    },
    // 官方发送，发送时间的限制
    limitSendTime() {
      getSendTime().then((res) => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + " - " + res.data.endTime;
        console.log("selectableRange:", selectableRange);
        this.expireTimeOption2.selectableRange = selectableRange;
      });
    },

    // 一键清空
    handleClearEmpty() {
      this.includePeople = [];
      this.excludePeople = [];
      this.includeRule = 1;
      this.excludeRule = 1;
      this.isExcludeFlag = false;
      this.filterAlreadySentFlag = false;
      this.filterDays = "";

      this.isEdit = false;//状态修改为新建状态
      this.editId = '';

      postSmsType(this.formData.smsType).then((res)=>{
        if (res.code == "1") {
          // this.$message.success("已一键清空!");
        } else {
          this.$message.error(res.message);
        }
      })

      this.formData = {
        activityTitle: "", // 活动主题
        content: "",
        jdShortLink: "",
        url: "", // 原始地址（非精准营销的短链接的原始地址）
        jdSmsSuffix: this.selectSuffix, // 短信签名
        sendSubmitNum: "", // 短信发送提交人数
        sendSubmitNumType: 0, // 0不限（官方） 填入买家余额 1人群包人数
        sendTime: "", //  发送时间 格式 yyyy-MM-dd HH:mm:ss
        // strategyInstId: '', // 实例化id
        /*** 官方参数 end */
        sendTime1: "", // yyyy-MM-dd
        sendTime2: "", // HH:mm:ss
        sendOutIpt: null, // 发送人数
        fitlerDay: "",
        fitlerDayNum: "", // 自定义输入人数
        blackFlag: true, // 黑名单
        badReviewFilterSetting: false, // 给过中差评客户
        refundFilterSetting: false, // 退过款客户
        mobileTypes: [], // 手机号段
        allMobile: true, // 不限
        jmlIds: [], // 悦信短网址链接id列表

        inputMobileStr: "", // 输入手机号
        sendIntType: 0,
        type: 1, // 指定号码发送-发送对象 1. 表示输入手机号码 2.表示上传手机号码
        mySendType: 0, // 0.立即发送 1.定时发送
        smsType: this.formData.smsType,
      };
      this.mobiles = "";
      this.mediaTestMobilesList = []
      this.isRichSmsTest = false
      this.returnData = {
        totalSize: 0, // 总大小
        mediaTitle: "", // 短信标题
        content: '', // 文本内容
        mediaList: [], // 富媒体列表
        jdSmsSuffix: '', // 短信签名
        sourceUrl: '' // 原链接
      } // 富信回显

 
    },

    // 切换按钮回显
    handleSmsType(type){
        var data = {};
        if(type==1){
          data=this.FuXinDate
        }else if(type==0){
          data=this.PuTongDate
        } else if(type==2){
          data=this.KaPianDate
        }
  
        // 是否有草稿记录：false 没有，true 有
        this.isEdit = data.hasRecord
        this.editId = data.id || ""
        this.preCardShow = false;
        if(data.smsType == 1){
          // 富信回显
          // console.log(data);
          console.log('回显===========================');
          this.richMessageData.content = data.content
          this.richMessageData.mediaTitle = data.mediaTitle
          this.richMessageData.sourceUrl = data.url || ""
          this.richMessageData.mediaList = JSON.parse(data.mediaListJsonArray) || []
          this.returnData.content = data.content
          this.returnData.mediaTitle = data.mediaTitle
          this.returnData.sourceUrl = data.url || ""
          this.returnData.mediaList = JSON.parse(data.mediaListJsonArray) || []
          this.formData.smsType = 1
          let row = this.mediaOptionList.find(o=>o.id == this.mediaId) || {}
          this.mediaTemplateId = row.mediaTemplateId
        }else if(type == 2){
          let row = this.cardOptionList.find(o=>o.id == this.cardId)
          if(row){
            this.mediaTemplateId = row.mediaTemplateId
            this.formData.content = row.text;
            this.formData.mediaTitle = row.title;
          }
          this.preCardShow = true;
        }else if(data.smsType == 0){
          this.formData.content = data.content || "";
          this.formData.smsType = 0
        }
        
        this.formData.activityTitle = data.activityTitle || "";
        console.log("this.formData.activityTitle111",this.formData.activityTitle)
        this.formData.mobiles = data.testPhone;
        if (data.sendNum && data.sendNum > 0) {
          this.formData.sendIntType = 1;
          this.formData.sendOutIpt = data.sendNum;
        } else {
          this.formData.sendIntType = 0;
        }

        if(this.formData.sendIntType === 0){
          this.formData.sendOutIpt = 0
        }

        var selectedCrowd = data.selectedCrowd;
        if (data.hasDeleteCrowd == "1") {
          this.$message.warning("选择人群已被删除哦~请重新选择人群");
        } else {
          if (data.hasUpdateCrowd == "1") {
            this.$message.warning("选择人群已被修改哦~请重新选择人群");
          }
        }
        if (selectedCrowd) {
          this.includePeople =[]
          this.excludePeople = []
          // selectedCrowd = JSON.parse(selectedCrowd)
          if (selectedCrowd.includeCrowd) {
            // 包括人群
            this.includePeople = selectedCrowd.includeCrowd || [];
          }
          if (selectedCrowd.includeSearchId) {
            this.includePeople =
              this.includePeople.concat(selectedCrowd.includeSearchId) || [];
          }
          if (selectedCrowd.excludeCrowd) {
            // 排除人群
            this.excludePeople = selectedCrowd.excludeCrowd || [];
          }
          if (selectedCrowd.excludeSearchId) {
            this.excludePeople =
              this.excludePeople.concat(selectedCrowd.excludeSearchId) || [];
          }

          // this.includePeople = selectedCrowd.includeCrowd || [];
          // this.excludePeople = selectedCrowd.excludeCrowd || [];
          this.includeRule = +selectedCrowd.includeRule !== 0 ? 1 : 0;
          this.excludeRule = +selectedCrowd.excludeRule !== 0 ? 1 : 0;
          this.isExcludeFlag = +selectedCrowd.excludeFlag === 1 || false;
          this.blacklisted = selectedCrowd.blacklisted || false;
          this.filterDays = selectedCrowd.filterDays || "";
          this.filterAlreadySentFlag =
            selectedCrowd.filterAlreadySentFlag || false;
          if (this.includePeople.length > 0) {
            let precisionCrowdStrategyIds = this.includePeople.map(
              (item) => item.precisionCrowdStrategyId
            );
            crowdCount({
              precisionCrowdStrategyIds: precisionCrowdStrategyIds,
            }).then((val) => {
              this.includePeople = this.includePeople.map((item) => {
                let obj = item;
                val.data.forEach((ele) => {
                  if (
                    item.precisionCrowdStrategyId ==
                    ele.precisionCrowdStrategyId
                  ) {
                    obj.count = ele.count;
                  }
                });
                return obj;
              });
            });
          }
          if (this.excludePeople.length > 0) {
            let precisionCrowdStrategyIds = this.excludePeople.map(
              (item) => item.precisionCrowdStrategyId
            );
            crowdCount({
              precisionCrowdStrategyIds: precisionCrowdStrategyIds,
            }).then((val) => {
              this.excludePeople = this.excludePeople.map((item) => {
                let obj = item;
                val.data.forEach((ele) => {
                  if (
                    item.precisionCrowdStrategyId ==
                    ele.precisionCrowdStrategyId
                  ) {
                    obj.count = ele.count;
                  }
                });
                return obj;
              });
            });
          }
        }
    },
    

    // 草稿回显
    hanleGetDraft() {
      getDraft().then((res) => {
        console.log("草稿回显",res.data);
        var data = res.data[0];

        // 是否有草稿记录：false 没有，true 有
        this.isEdit = data.hasRecord
        this.editId = data.id || ""

        res.data.forEach(item=>{
          if(item.smsType == 1){
            this.FuXinDate=item
          }else if(item.smsType == 2){
            this.KaPianDate=item
          }else if(item.smsType == 0){
            this.PuTongDate=item
          }
        })

        if(data.smsType == 1){
          // 富信回显
          // console.log(data);
         
          this.richMessageData.content = data.content
          this.richMessageData.mediaTitle = data.mediaTitle
          this.richMessageData.sourceUrl = data.url || ""
          this.richMessageData.mediaList = JSON.parse(data.mediaListJsonArray) || []
          this.returnData.content = data.content
          this.returnData.mediaTitle = data.mediaTitle
          this.returnData.sourceUrl = data.url || ""
          this.returnData.mediaList = JSON.parse(data.mediaListJsonArray) || []
          this.formData.smsType = 1
          if(this.sendType == 1){
            this.mediaId2 = data.mediaTemplateId
            if(this.mediaOptionList && this.mediaOptionList.length > 0){
              let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.mediaId2)
              this.mediaId = row.id
              this.changeMedia();
            }
            
          }
        }else if(data.smsType == 2){
          console.log('回显===========================',this.sendType,data,this.cardOptionList);
          if(this.sendType == 1){
            this.cardId2 = data.mediaTemplateId
            this.formData.smsType = 2
            let failBackConfig = data.failBackConfig
            this.failBackConfig.content = failBackConfig.content;
            this.failBackConfig.failBackType = failBackConfig.failBackType 
            this.failBackConfig.id = failBackConfig.id 
            this.failBackConfig.jdShortLink = failBackConfig.jdShortLink 
            this.failBackConfig.mediaMulitiFileId = failBackConfig.mediaMulitiFileId 
            this.failBackConfig.mediaTemplateId = failBackConfig.mediaTemplateId 
            this.failBackConfig.realUrl = failBackConfig.realUrl 
            if(this.cardOptionList && this.cardOptionList.length > 0){
              let row = this.cardOptionList.find(o=>o.mediaTemplateId == this.cardId2)
              this.cardId = row.id
              this.changeCard();
              console.log('cardId: ', this.cardId)
            }
          }

        }else if(data.smsType == 0){
          this.formData.content = data.content || "";
          this.formData.smsType = 0
        }
        
        this.formData.activityTitle = data.activityTitle || "";
        console.log("this.formData.activityTitle111",this.formData.activityTitle)
        this.formData.mobiles = data.testPhone;
        if (data.sendNum && data.sendNum > 0) {
          this.formData.sendIntType = 1;
          this.formData.sendOutIpt = data.sendNum;
        } else {
          this.formData.sendIntType = 0;
        }

        if(this.formData.sendIntType === 0){
          this.formData.sendOutIpt = 0
        }

        var selectedCrowd = data.selectedCrowd;
        if (data.hasDeleteCrowd == "1") {
          this.$message.warning("选择人群已被删除哦~请重新选择人群");
        } else {
          if (data.hasUpdateCrowd == "1") {
            this.$message.warning("选择人群已被修改哦~请重新选择人群");
          }
        }
        if (selectedCrowd) {
          // selectedCrowd = JSON.parse(selectedCrowd)
          if (selectedCrowd.includeCrowd) {
            // 包括人群
            this.includePeople = selectedCrowd.includeCrowd || [];
          }
          if (selectedCrowd.includeSearchId) {
            this.includePeople =
              this.includePeople.concat(selectedCrowd.includeSearchId) || [];
          }
          if (selectedCrowd.excludeCrowd) {
            // 排除人群
            this.excludePeople = selectedCrowd.excludeCrowd || [];
          }
          if (selectedCrowd.excludeSearchId) {
            this.excludePeople =
              this.excludePeople.concat(selectedCrowd.excludeSearchId) || [];
          }

          // this.includePeople = selectedCrowd.includeCrowd || [];
          // this.excludePeople = selectedCrowd.excludeCrowd || [];
          this.includeRule = +selectedCrowd.includeRule !== 0 ? 1 : 0;
          this.excludeRule = +selectedCrowd.excludeRule !== 0 ? 1 : 0;
          this.isExcludeFlag = +selectedCrowd.excludeFlag === 1 || false;
          this.blacklisted = selectedCrowd.blacklisted || false;
          this.filterDays = selectedCrowd.filterDays || "";
          this.filterAlreadySentFlag =
            selectedCrowd.filterAlreadySentFlag || false;
          if (this.includePeople.length > 0) {
            let precisionCrowdStrategyIds = this.includePeople.map(
              (item) => item.precisionCrowdStrategyId
            );
            crowdCount({
              precisionCrowdStrategyIds: precisionCrowdStrategyIds,
            }).then((val) => {
              this.includePeople = this.includePeople.map((item) => {
                let obj = item;
                val.data.forEach((ele) => {
                  if (
                    item.precisionCrowdStrategyId ==
                    ele.precisionCrowdStrategyId
                  ) {
                    obj.count = ele.count;
                  }
                });
                return obj;
              });
            });
          }
          if (this.excludePeople.length > 0) {
            let precisionCrowdStrategyIds = this.excludePeople.map(
              (item) => item.precisionCrowdStrategyId
            );
            crowdCount({
              precisionCrowdStrategyIds: precisionCrowdStrategyIds,
            }).then((val) => {
              this.excludePeople = this.excludePeople.map((item) => {
                let obj = item;
                val.data.forEach((ele) => {
                  if (
                    item.precisionCrowdStrategyId ==
                    ele.precisionCrowdStrategyId
                  ) {
                    obj.count = ele.count;
                  }
                });
                return obj;
              });
            });
          }
        }
      });
    },

    // 编辑回显
    hanleEditItem(nVal) {
        console.log("回显",this.editItem);
        var data = nVal || this.editItem;
        this.editId = data.id
        this.isEdit = true

        if(data.smsType == 1){
          // 富信回显
          this.FuXinDate=data
          // console.log(data);
          console.log('回显===========================');
          this.richMessageData.content = data.content
          this.richMessageData.mediaTitle = data.mediaTitle
          this.richMessageData.sourceUrl = data.url || ""
          this.richMessageData.mediaList = JSON.parse(data.mediaListJsonArray) || []
          this.returnData.content = data.content
          this.returnData.mediaTitle = data.mediaTitle
          this.returnData.sourceUrl = data.url || ""
          this.returnData.mediaList = JSON.parse(data.mediaListJsonArray) || []
          this.formData.smsType = 1
          if(this.sendType == 1){
            this.mediaId2 = data.mediaTemplateId
            if(this.mediaOptionList && this.mediaOptionList.length > 0){
              let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.mediaId2)
              this.mediaId = row.id
              this.changeMedia();
            }
            
          }
        }else if(data.smsType == 0){
          this.PuTongDate = data
          this.formData.content = data.content || "";
          this.formData.smsType = 0
        }else if(data.smsType == 2){
          this.KaPianDate = data
          this.formData.content = data.content || "";
          this.formData.smsType = 2;
          let failBackConfig = data.failBackConfig
          this.failBackConfig.content = failBackConfig.content;
          this.failBackConfig.failBackType = failBackConfig.failBackType 
          this.failBackConfig.id = failBackConfig.id 
          this.failBackConfig.jdShortLink = failBackConfig.jdShortLink 
          this.failBackConfig.mediaMulitiFileId = failBackConfig.mediaMulitiFileId 
          this.failBackConfig.mediaTemplateId = failBackConfig.mediaTemplateId 
          this.failBackConfig.realUrl = failBackConfig.realUrl 
          if(this.sendType == 1){
            // this.changeFailMedia();
            this.cardId2 = data.mediaTemplateId
            if(this.cardOptionList && this.cardOptionList.length > 0){
              let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.cardId2)
              this.cardId = row.id
              this.changeMedia();
            }
            
          }
        }

        this.formData.activityTitle = data.activityTitle || "";
        this.formData.mobiles = data.testPhone;
        if (data.sendNum && data.sendNum > 0) {
          this.formData.sendIntType = 1;
          this.formData.sendOutIpt = data.sendNum;
        } else {
          this.formData.sendIntType = 0;
        }

        if(this.formData.sendIntType == 0){
          this.formData.sendOutIpt = 0
        }

        var selectedCrowd = data.selectedCrowd;
        if (data.hasDeleteCrowd == "1") {
          this.$message.warning("选择人群已被删除哦~请重新选择人群");
        } else {
          if (data.hasUpdateCrowd == "1") {
            this.$message.warning("选择人群已被修改哦~请重新选择人群");
          }
        }
        if (selectedCrowd) {
          this.includePeople =[]
          this.excludePeople = []
          // selectedCrowd = JSON.parse(selectedCrowd)
          if (selectedCrowd.includeCrowd) {
            // 包括人群
            this.includePeople = selectedCrowd.includeCrowd || [];
          }
          if (selectedCrowd.includeSearchId) {
            this.includePeople =
              this.includePeople.concat(selectedCrowd.includeSearchId) || [];
          }
          if (selectedCrowd.excludeCrowd) {
            // 排除人群
            this.excludePeople = selectedCrowd.excludeCrowd || [];
          }
          if (selectedCrowd.excludeSearchId) {
            this.excludePeople =
              this.excludePeople.concat(selectedCrowd.excludeSearchId) || [];
          }

          // this.includePeople = selectedCrowd.includeCrowd || [];
          // this.excludePeople = selectedCrowd.excludeCrowd || [];
          this.includeRule = +selectedCrowd.includeRule !== 0 ? 1 : 0;
          this.excludeRule = +selectedCrowd.excludeRule !== 0 ? 1 : 0;
          this.isExcludeFlag = +selectedCrowd.excludeFlag === 1 || false;
          this.blacklisted = selectedCrowd.blacklisted || false;
          this.filterDays = selectedCrowd.filterDays || "";
          this.filterAlreadySentFlag =
            selectedCrowd.filterAlreadySentFlag || false;
          if (this.includePeople.length > 0) {
            let precisionCrowdStrategyIds = this.includePeople.map(
              (item) => item.precisionCrowdStrategyId
            );
            crowdCount({
              precisionCrowdStrategyIds: precisionCrowdStrategyIds,
            }).then((val) => {
              this.includePeople = this.includePeople.map((item) => {
                let obj = item;
                val.data.forEach((ele) => {
                  if (
                    item.precisionCrowdStrategyId ==
                    ele.precisionCrowdStrategyId
                  ) {
                    obj.count = ele.count;
                  }
                });
                return obj;
              });
            });
          }
          if (this.excludePeople.length > 0) {
            let precisionCrowdStrategyIds = this.excludePeople.map(
              (item) => item.precisionCrowdStrategyId
            );
            crowdCount({
              precisionCrowdStrategyIds: precisionCrowdStrategyIds,
            }).then((val) => {
              this.excludePeople = this.excludePeople.map((item) => {
                let obj = item;
                val.data.forEach((ele) => {
                  if (
                    item.precisionCrowdStrategyId ==
                    ele.precisionCrowdStrategyId
                  ) {
                    obj.count = ele.count;
                  }
                });
                return obj;
              });
            });
          }
        }
    },

    // 保存草稿
    handleSaveDraft() {
      console.log('this.formData.smsType------>', this.formData)
      console.log('this.richMessageData------>', this.richMessageData)
      // var excludeStrategyIdList = [];
      if (this.formData.sendIntType == 1 && this.formData.sendOutIpt < 2) {
        this.$message.warning("限制发送数必须大于大于2");
        return;
      }

      var excludeFlag = this.isExcludeFlag ? "1" : "0";
      var includeIds = [];
      var excludeIds = [];
      var includeSearchIds = [];
      var excludeSearchIds = [];

      this.includePeople.forEach((item, index) => {
        var temp = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId,
          name: item.name,
          count: item.count,
        };
        if (item.searchId && item.searchId.length > 0) {
          temp.searchId = item.searchId;
          includeSearchIds.push(temp);
        } else {
          temp.strategy = item.strategy;
          includeIds.push(temp);
        }

        // includeIdList.push(item.strategyId);
      });

      this.excludePeople.forEach((item) => {
        var temp = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId,
          name: item.name,
        };

        if (item.searchId && item.searchId.length > 0) {
          temp.searchId = item.searchId;
          excludeSearchIds.push(temp);
        } else {
          temp.strategy = item.strategy;
          excludeIds.push(temp);
        }
        // excludeStrategyIdList.push(item.strategyId);
      });

      // console.log("includeStrategyIdList:", includeIdList);
      var param = {
        // includeStrategyIdList: includeIdList,
        includeRule: this.includeRule, // 0 交集 1.并集
        excludeFlag, // 0 不选择排除人群 1. 选择
        includeSearchId: includeSearchIds,
        includeCrowd: includeIds,
        blacklisted: this.blacklisted,
        filterAlreadySentFlag: this.filterAlreadySentFlag,
        filterDays: this.filterDays,
      };
      if (this.isExcludeFlag) {
        param.excludeSearchId = excludeSearchIds;
        param.excludeCrowd = excludeIds;
        param.excludeRule = this.excludeRule;
      }

      var param2 = {
        activityTitle: this.formData.activityTitle ||  "精准营销" + this.getNowDate(3),
        content: this.formData.content,
        sendNum: this.formData.sendOutIpt,
        testPhone: this.mobiles,
        smsType: this.formData.smsType,
      };
      // Object.assign(param2, param);
      param2.selectedCrowd = JSON.stringify(param);
      // 富信类型参数
      if(param2.smsType == 1) {
        // if(this.richMessageData.mediaTitle == "") {
        //   this.$message.error("富信标题不能为空")
        //   return
        // }
        // if(this.richMessageData.content == "") {
        //   this.$message.error("富信内容不能为空")
        //   return
        // }
        param2.mediaTitle = this.richMessageData.mediaTitle
        param2.content = this.richMessageData.content,
        param2.mediaListJsonArray = JSON.stringify(this.richMessageData.mediaList)
        param2.url = this.richMessageData.sourceUrl
        param2.mediaTemplateId = this.mediaTemplateId
      }
      if(param2.smsType == 2) {
        param2.mediaTitle = this.formData.mediaTitle
        param2.mediaTemplateId = this.mediaTemplateId
        let failBackConfig = {...this.failBackConfig}
        if(failBackConfig.failBackType == 1){
          failBackConfig.content += this.TTip;
        }
        param2.failBackConfigStr = JSON.stringify(failBackConfig)
        
      }
      param2.id = this.editId || ""

      console.log('param2------>', param2)
      saveDraft(param2).then((res) => {
        if (res.code == "1") {
          this.$message.success("保存成功，可在草稿箱查看！");
          this.isEdit = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    smsDialogClose(data) {
      console.log(data, 111);
      this.smsDialogs = data;
    },
    transferName() {
      this.smsDialogs = false;
    },
    goSuffixUrl() {
      // var url = "/backstage/signature_management/signature_management",
      //     index = 7;
      // this.bus.$emit("topActive", { index: index, item: this.$store.state.route[index]});
      // this.$router.push({
      //   path: url
      // })
      let routeUrl = "";
      if (this.smsType == "1" || this.smsType == "2") {
        // 官方短信签名
        routeUrl = this.$router.resolve({
          path: "/backstage/signature_management/signature_report_official",
        });
      } else {
        // 平台短信签名跳转
        routeUrl = this.$router.resolve({
          path: "/backstage/signature_management/signature_management",
        });
      }

      window.open(routeUrl.href, "_blank");
    },
    goBlackUrl() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 继续发送
    handleConSending() {
      if (this.sendType != 3) {
        this.successDialog = false;
      } else {
        // 订单发送
        this.$emit("onConSending");
      }
    },
    // 查看记录
    handleViewRecord() {
      this.successDialog = false;
      if (this.isEffectSend) {
        if (this.effectParam.taskId) {
          // 汇总的跳转
          this.bus.$emit("topHeader", {
            index: 3,
            item: this.$store.state.route[3],
          });
          this.$router.push({
            path: "/marketing/marketing/member_send",
            query: { to: "smsRecord" },
          });
        } else {
          // 效果分析的跳转
          this.bus.$emit("viewRecords");
        }
        return;
      }
      this.$emit("onViewRecord");
    },
    // 跳转签名页面
    routerSign() {
      // var routeUrl =
    },

    init() {
      // 按钮权限显示
      if (
        this.permissions &&
        this.permissions.indexOf("hide:filter:send") != "-1"
      ) {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
      if (
        this.permissions &&
        this.permissions.indexOf("hide:filter:refund") != "-1"
      ) {
        this.isPreRefund = true;
      }

      if (
        this.permissions &&
        this.permissions.indexOf("hide:filter:evaluate") != "-1"
      ) {
        this.isPreEvaluate = true;
      }

      // 再次营销发送数据回显
      this.showReSend();

      // 效果分析传参解析
      console.log("this.sendType：", this.sendType);
      if (this.sendType == "1") {
        // 精准营销
        this.smsType = 1;
        this.showSendSendData();

        if (this.$route.query && this.$route.query.to == "grouping") {
        } else {
          if (!this.precisionMData) {
            this.hanleGetDraft();
          }
        }
      } else if (this.sendType == "2") {
        // 官方  会员发送
        this.smsType = 2;
        if (
          this.effectParam &&
          (this.effectParam.taskId || this.effectParam.bid)
        ) {
          this.isEffectSend = true;
          this.effectRadio = this.effectParam.sendObjectType;
          this.effectRadioList = this.effectParam.effectSelect;
        }

        this.preCommitSend(false);

        // this.sendPeopleNum = this.conditionNum;
      } else if (this.sendType == "3") {
        // 官方 订单发送
        this.smsType = 2;
        this.preCommitSend(false);
      } else if (this.sendType == "15") {
        // 官方 订单发送
        this.smsType = 2;
        this.preCommitSend(false);
      } else {
        // 系统
        this.smsType = 3;
        if (
          this.effectParam &&
          (this.effectParam.taskId || this.effectParam.bid)
        ) {
          this.isEffectSend = true;
          this.effectRadio = this.effectParam.sendObjectType;
          this.effectRadioList = this.effectParam.effectSelect;
          this.preCommitSend(false);
          return;
        }

        // 指定号码发送变量短信发送的回显
        var uploadAgainDB = this.uploadAgainDB;
        if (uploadAgainDB && uploadAgainDB.fid) {
          this.uploadObj = uploadAgainDB;
          this.sendPeopleNum = uploadAgainDB.totalMobile;
          this.formData.content = uploadAgainDB.content;
          if (this.sendType == "4") {
            this.formData.type = 2;
          }
          console.log("uploadAgainDB", uploadAgainDB);
        }
      }
    },

    // 手机号码输入框
    handleMobileInput() {
      var inputMobileStr = this.formData.inputMobileStr;
      var list = [];
      if (inputMobileStr.indexOf(",") != "-1") {
        list = inputMobileStr.split(",");
      } else {
        list = [inputMobileStr];
      }

      this.sendPeopleNum = list.length;
    },

    // 手机号文件导入
    handleImportPhone(obj) {
      this.showPhoneDialog = false;
      if (obj.flag) {
        this.uploadObj = obj;
        this.sendPeopleNum = obj.totalMobile;
        if (this.sendType == "5") {
          var param = {
            fid: obj.fid,
          };
          getLabel(param).then((res) => {
            var list = [];
            if (res.code == "1") {
              list = res.data;
              if (list && list.length > 0) {
                list = list.map(function (item, index) {
                  item = "#" + item + "#";
                  return item;
                });
              }
            }
            this.variableList = list || [];
          });
        }
      }
      console.log(obj);
    },

    // 模板下载 type: 1.指定号码发送的EXCEEL 模板下载 2.变量短信发送的EXCEL 模板下载
    downloadTemplate(type) {
      let url = "";
      let fileName = "";
      if (type == "1") {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/excel_import_send.xlsx";
        fileName = "excel_variate_send.xlsx";
      } else if (type == "2") {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/excel_variate_send.xlsx";
        name = "excel_import_send.xlsx";
      }
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },

    // 手机号码段全选
    handleAllMobile(val) {
      if (val) {
        this.formData.mobileTypes = [];
      }
    },

    // 手机号段勾选问题
    handleSelectMobile(val) {
      console.log(val);
      if (val.length > 0) {
        this.formData.allMobile = false;
      }
    },
    // 短信二次发送信息回显
    showReSend() {
      var data = this.reSendSmsObj;
      // console.log("reSendSmsObj:", this.reSendSmsObj);
      console.log(data);
      if (data && data.flag) {
        this.formData.activityTitle = data.activityTitle;
        this.formData.smsType = data.smsType
        if(data.smsType == 1){
          mediaDetail(data.mediaMulitiFileId).then(res=>{
            if(res.code == 1){
              this.returnData.mediaList = res.data.map(item => item)
            }
          })
          this.returnData.mediaTitle = data.mediaTitle
          this.returnData.content = data.content
          this.returnData.jdSmsSuffix = this.jdSmsSuffix
        }else{
          if (data.content.indexOf("拒收请回复R") != "-1") {
            this.formData.content = data.content.substr(
              0,
              data.content.indexOf("拒收请回复R")
            );
          }
        }
        if (data.jdShortLink) {
          if(data.smsType == 1){
            this.returnData.sourceUrl = data.url
            this.returnData.jdShortLink = data.jdShortLink
          }
          this.formData.jdShortLink = data.jdShortLink;
          this.formData.url = data.url;
          this.jdShortLinkList = [
            {
              shortLink: data.jdShortLink,
              originUrl: data.url,
            },
          ];
        }
        if (data.sendTime) {
          this.formData.sendTime1 = data.sendTime.substr(0, 10);
          this.formData.sendTime2 = data.sendTime.substr(11, 8);
        }

        this.formData.fitlerDay = data.filterDay;
        if (
          data.fitlerDay &&
          data.fitlerDay != "3" &&
          data.fitlerDay != "5" &&
          data.fitlerDay != "7" &&
          data.fitlerDay != "15"
        ) {
          this.formData.fitlerDayNum = data.fitlerDay;
          this.formData.fitlerDay = -1;
        }
      }
    },

    // 精准营销二次发送的回显
    showSendSendData() {
      var precisionMData = this.precisionMData;
      console.log(precisionMData);
      if (precisionMData && precisionMData.selectedCrowd) {
        if (precisionMData.sendSubmitNumType == "1") {
          this.formData.sendIntType = 1;
          this.formData.sendOutIpt = precisionMData.sendSubmitNum;
        } else {
          this.formData.sendIntType = 0;
          this.formData.sendOutIpt = "";
        }
        this.formData.activityTitle = precisionMData.title;
        if(precisionMData.smsType == 1){
          this.formData.smsType = precisionMData.smsType
          setTimeout(()=>{
            this.returnData.content = precisionMData.content;
            this.returnData.mediaTitle = precisionMData.mediaTitle;
            this.returnData.sourceUrl = precisionMData.url;
            this.returnData.mediaList = JSON.parse(precisionMData.mediaListJsonArray);
          },500)
        }else{
          if (precisionMData.content.indexOf("拒收请回复R") != "-1") {
            precisionMData.content = precisionMData.content.substr(
              0,
              precisionMData.content.indexOf("拒收请回复R")
            );
          }
          this.formData.content = precisionMData.content;
        }
        // this.formData.sendTime1 = precisionMData.sentTime.substr(0,10);
        // this.formData.sendTime2 = precisionMData.sentTime.substr(11);

        this.includePeople = precisionMData.selectedCrowd.includeCrowd || [];
        this.excludePeople = precisionMData.selectedCrowd.excludeCrowd || [];
        if (precisionMData.selectedCrowd.includeSearchId) {
          // 包括人群
          this.includePeople =
            this.includePeople.concat(
              precisionMData.selectedCrowd.includeSearchId
            ) || [];
        }
        if (precisionMData.selectedCrowd.excludeSearchId) {
          this.excludePeople =
            this.excludePeople.concat(
              precisionMData.selectedCrowd.excludeSearchId
            ) || [];
        }

        this.includeRule = precisionMData.selectedCrowd.includeRule;
        this.excludeRule = precisionMData.selectedCrowd.excludeRule;
        this.isExcludeFlag = precisionMData.selectedCrowd.excludeFlag == "1";
        this.blacklisted = precisionMData.selectedCrowd.blacklisted || false;
        this.filterDays = precisionMData.selectedCrowd.filterDays || "";
        this.filterAlreadySentFlag =
          precisionMData.selectedCrowd.filterAlreadySentFlag || false;

        if (this.includePeople.length > 0) {
          let precisionCrowdStrategyIds = this.includePeople.map(
            (item) => item.precisionCrowdStrategyId
          );
          crowdCount({
            precisionCrowdStrategyIds: precisionCrowdStrategyIds,
          }).then((val) => {
            this.includePeople = this.includePeople.map((item) => {
              let obj = item;
              val.data.forEach((ele) => {
                if (
                  item.precisionCrowdStrategyId == ele.precisionCrowdStrategyId
                ) {
                  obj.count = ele.count;
                }
              });
              return obj;
            });
          });
        }
        if (this.excludePeople.length > 0) {
          let precisionCrowdStrategyIds = this.excludePeople.map(
            (item) => item.precisionCrowdStrategyId
          );
          crowdCount({
            precisionCrowdStrategyIds: precisionCrowdStrategyIds,
          }).then((val) => {
            this.excludePeople = this.excludePeople.map((item) => {
              let obj = item;
              val.data.forEach((ele) => {
                if (
                  item.precisionCrowdStrategyId == ele.precisionCrowdStrategyId
                ) {
                  obj.count = ele.count;
                }
              });
              return obj;
            });
          });
        }

        // if (this.includePeople && this.includePeople.length > 0) {
        //   this.includePeople.forEach((item) => {
        //     item.name = item.strategyName;
        //   });
        // }
        // if (this.excludePeople && this.excludePeople.length > 0) {
        //   this.excludePeople.forEach((item) => {
        //     item.name = item.strategyName;
        //   });
        // }
        if (precisionMData.hasDeleteCrowd) {
          this.$message.warning("选择人群已被删除哦~请重新选择人群");
        } else if (precisionMData.hasUpdateCrowd) {
          this.$message.warning("选择人群已被修改哦~请重新选择人群");
        }
      }
    },

    // 显示短链接弹窗
    handleShowShortLink() {
      console.log("this.insertShortUrlShow:", this.insertShortUrlShow);
      if (this.smsType != "3") {
      }
      this.insertShortUrlShow = true;
    },

    // 测试短信发送前的弹窗提示
    async handleShowSendTip() {
      var mobiles = this.mobiles;
      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      // 替换逗号(不论中/英文逗号，都替换成英文逗号)
      mobiles = mobiles.replace(/(,|，)/g, ",");
      // 切换成数组
      var mobleList = mobiles.split(",");
      var mobileArr = [];
      for (var i = 0; i < mobleList.length; i++) {
        if (/^1[3456789]\d{9}$/.test(mobleList[i])) {
          mobileArr.push(mobleList[i]);
        }
      }

      var newMobleArr = [];
      for (var i = 0; i < mobileArr.length; i++) {
        if (newMobleArr.indexOf(mobileArr[i]) == -1) {
          newMobleArr.push(mobileArr[i]);
        }
      }
      if (newMobleArr.length <= 0) {
        this.$message.warning("号码无效，请输入有效号码 !");
        return;
      }
      // if (newMobleArr.length > 5) {
      //   this.$message.warning("测试发送最多只能发送5个有效号码 !");
      //   return;
      // }

      var content = this.formData.content;
      // 敏感词检测
      const checkResult = await this.$wordCheck({ content: this.formData.content })
      if (checkResult.code != 1) {
        return this.$message.error(checkResult.message)
      }
      if (content && content.trim().length > 0) {
        this.mobiles = newMobleArr.join(",");
        // this.strLenght = content.length + this.formData.jdSmsSuffix.length;
        this.phoneLenght = this.mobiles.split(",").length;
        this.isTestSend = true;
        this.showSendConfirm = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },
    // 点击运算按钮
    handleCaculate() {
      if (this.includePeople.some(item => item.type ==15) || this.excludePeople.some(item => item.type ==15)) {
      this.$confirm('当前计算涉及官方人群策略，预计等待时间较长，您确认要现在执行计算吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.handleSure()
       }).catch(() => {
          this.$message({
           type: 'info',
           message: '已取消'
         });          
       });
     }else{
      this.handleSure()
     }
    },
    handleSure(){
      console.log(this.includePeople);
      // 3.2新增需求 人群数为0无法运算
      if(this.includePeople.filter(item=>item.count==0).length){
        this.$message.error("所选人群中存在数量为0人群，请删除该人群后再进行运算");
        return
      }
      // var includeIdList = [];
      var excludeStrategyIdList = [];
      var excludeFlag = this.isExcludeFlag ? "1" : "0";
      var includeIds = [];
      var excludeIds = [];
      var includeSearchIds = [];
      var excludeSearchIds = [];

      if (excludeFlag == "1" && this.excludePeople.length == "0") {
        // 勾选排除人群，限制必须选择人群
        this.$message.warning("请先选择排除人群哦~");
        return;
      }
      if (
        this.isPremissionShow &&
        this.filterAlreadySentFlag &&
        !this.filterDays
      ) {
        this.$message.warning("屏蔽天数不能为空哦~");
        return;
      }

      this.includePeople.forEach((item, index) => {
        var temp = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId,
          name: item.name,
          count: item.count,
        };
        if (item.searchId && item.searchId.length > 0) {
          temp.searchId = item.searchId;
          includeSearchIds.push(temp);
        } else {
          temp.strategy = item.strategy;
          includeIds.push(temp);
        }

        // includeIdList.push(item.strategyId);
      });

      this.excludePeople.forEach((item) => {
        var temp = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId,
          name: item.name,
        };

        if (item.searchId && item.searchId.length > 0) {
          temp.searchId = item.searchId;
          excludeSearchIds.push(temp);
        } else {
          temp.strategy = item.strategy;
          excludeIds.push(temp);
        }
        // excludeStrategyIdList.push(item.strategyId);
      });

      // console.log("includeStrategyIdList:", includeIdList);
      var param = {
        // includeStrategyIdList: includeIdList,
        includeRule: this.includeRule, // 0 交集 1.并集
        excludeFlag, // 0 不选择排除人群 1. 选择
        includeSearchId: includeSearchIds,
        includeCrowd: includeIds,
      };
      if (this.isExcludeFlag) {
        param.excludeSearchId = excludeSearchIds;
        param.excludeCrowd = excludeIds;
        param.excludeRule = this.excludeRule;
      }
      this.computeLoading = true;
      this.requestNum = 20;
      console.log("param:", param);
      var paramX = {
        selectedCrowd: JSON.stringify(param),
      };
      param.blacklisted = this.blacklisted;
      param.filterAlreadySentFlag = this.filterAlreadySentFlag;
      param.filterDays = this.filterDays;
      this.sendPeopleNum = 0;
      caculateMember(param).then((res) => {
        console.log(res);
        this.computeLoading = false;
        if (res.code == "1") {
          // 遍历循环挖包
          // this.computeData.count = res.data.count;
          this.computeData.strategyInstId = res.data.strategyInstId;
          this.handlePackStatus();
        } else {
          console.log("error");
          this.$message.error(res.message);
        }
      });
    },
    // 重复挖包
    handlePackStatus() {
      this.requestNum--;
      var that = this;
      if (this.requestNum < 1) {
        this.$message.error("筛选人群失败");
        this.computeLoading = false;
        return;
      }
      var param = {
        strategyInstId: this.computeData.strategyInstId,
      };
      this.computeLoading = true;
      setTimeout(() => {
        packStatus(param).then((res) => {
          console.log("packStatus==", res);
          if (res.code == "1") {
            this.computeLoading = false;
            this.sendPeopleNum = res.data.crowdSize; // 人群数量
            this.crowdStatus = res.data.crowdStatus; // 人群包状态
          } else {
            var timeout = setTimeout(function () {
              that.handlePackStatus();
            });
          }
        });
      }, 1000);
    },
    //数组排重
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    // 提交发送按钮
    async handleSend() {
      
      if(this.formData.smsType == 1){
        this.formData.mediaTitle = this.richMessageData.mediaTitle
        this.formData.mediaList = this.richMessageData.mediaList
        this.formData.content = this.richMessageData.content
      }
      // console.log(this.formData.content,this.richMessageData.content);

      if(this.formData.smsType == 1){
        // if(this.formData.mediaTitle == ""){
        //   this.$message.warning("请输入富信标题");
        //   return;
        // }
        // if( this.formData.content == ""){
        //   this.$message.warning("请输入富信内容");
        //   return;
        // }
        if( !this.mediaId){
          this.$message.warning("请选择富信模板");
          return;
        }
        if(this.isTestSend && this.formData.mediaTestMobiles == ''){
          this.$message.warning("请选择测试手机号");
          return;
        }
        if( this.richMessageData.sourceUrl == ""){
          this.$message.warning("请插入短链接");
          return;
        }
      }
      if(this.formData.smsType == 2){
        if( !this.cardId){
          this.$message.warning("请选择卡片短信模板");
          return;
        }
        if(this.failBackConfig.failBackType == 1 && !this.failBackConfig.content){
          this.$message.warning("请填写回落短信内容");
          return;
        }
        if(this.failBackConfig.failBackType == 2 && !this.failBackConfig.mediaTemplateId){
          this.$message.warning("请选择回落富信模板");
          return;
        }
      }

      if (this.$route.path == "/marketing/marketing/designated_send") {
        if (this.formData.type == 1) {
          if (this.formData.inputMobileStr == "") {
            this.$message.warning("请输入发送对象");
            return;
          }
        }
        if (this.formData.type == 2) {
          if (this.sendPeopleNum == 0) {
            this.$message.warning("请选择发送对象");
            return;
          }
        }
      }

      if (this.sendType == "1") {
        // 精准营销
        if (this.formData.sendIntType == 1 && this.formData.sendOutIpt < 2) {
          this.$message.warning("限制发送数必须大于大于2");
          return;
        }
        if (this.computeLoading) {
          this.$message.warning(
            " 正在计算人群，请计算完人群再进行下一步操作哦~"
          );
          return;
        }

        if (this.sendPeopleNum == "0") {
          this.$message.warning(
            "人群数为0，无法进行下一步操作哦~ 请重新选择人群计算"
          );
          return;
        }
      }
      // console.log(this.formData.mySendType);
      if (this.formData.mySendType == 1) {
        let year = new Date().getFullYear();
        let year1 = new Date().getFullYear() + 1;
        let month =
          new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1;
        let date =
          new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate();
        let hh =
          new Date().getHours() < 10
            ? "0" + new Date().getHours()
            : new Date().getHours();
        let mm =
          new Date().getMinutes() < 10
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes();
        let ss =
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds();
        let path = this.formData.sendTime1.split("-");
        let year2 = parseInt(path[0]);
        let month1 = parseInt(path[1]);
        let month2 = month1 + 1 < 10 ? "0" + month1 + 1 : month1 + 1;
        let date1 = parseInt(path[2]);
        let date2 = new Date(year2, month1, 0).getDate();
        let month3 = "01";
        let date3 = "01";
        let date4 = date1 + 1 < 10 ? "0" + date1 + 1 : date1 + 1;
        let path1 = this.formData.sendTime2.split(":");
        let end =
          parseInt(path1[0]) * 3600 +
          parseInt(path1[1]) * 60 +
          parseInt(path1[2]);
        let time1 = 25200;
        let time2 = 79200;
        if (end < time1) {
          this.formData.sendTime2 = "07:00:00";
        } else if (end >= time2) {
          if (date2 == date1 && month1 == 12) {
            this.formData.sendTime1 = `${year1}-${month3}-${date3}`;
            this.formData.sendTime2 = "07:00:00";
          } else if (date2 == date1 && month1 < 12) {
            this.formData.sendTime1 = `${year2}-${month2}-${date3}`;
            this.formData.sendTime2 = "07:00:00";
          } else if (date2 < date1) {
            this.formData.sendTime1 = `${year2}-${month2}-${date4}`;
            this.formData.sendTime2 = "07:00:00";
          }
        }
      }
      // console.log(this.formData.sendTime2);
      // console.log(this.formData.sendTime1);
      // 校验必填项 短信内容， 发送时间， 签名
      var content = this.formData.content;
      var sendTime1 = this.formData.sendTime1;
      var sendTime2 = this.formData.sendTime2;
      // console.log(content);
      if (!(content && content.trim().length > 0)) {
        this.$message.warning("短信内容不能为空哦！");
        return;
      } else {
        // 不能含有【 或 】 的字符
        if (content.indexOf("【") !== -1 || content.indexOf("】") !== -1) {
          this.$message.warning("通道规则：短信内容请勿包含【】符号！");
          return;
        }
      }
      // 官方发送的短链接校验
      var num = 0; // 还有的短链接数
      this.jdShortLinkList.forEach((item) => {
        var shortLink = item.shortLink;
        if (content.indexOf(shortLink) != "-1") {
          num++;
          this.formData.jdShortLink = shortLink;
          this.formData.url = item.originUrl;
        }
      });
      // console.log(
      //   "num:==",
      //   num,
      //   this.jdShortLinkList,
      //   this.formData.content.match(/3\.cn/g)
      // );
      if (this.isRepeat(this.formData.content.match(/3\.cn/g))) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      }
      if (num > 1) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      } else if (num == "0") {
        this.formData.jdShortLink = "";
      }

      if (
        this.smsType != "3" ||
        (this.smsType == "3" && this.formData.mySendType == "1")
      ) {
        // 非系统发送或者系统发送的定时发送
        if (
          !(
            sendTime1 &&
            sendTime1.trim().length > 0 &&
            sendTime2 &&
            sendTime2.trim().length > 0
          )
        ) {
          this.$message.warning("请填写发送时间！");
          return;
        }
      }
      if(this.formData.smsType == 1 && this.isRichSmsTest&&this.formData.mediaTestMobiles.length==0){
        this.$message.info('请选择测试手机号!');
        return
      }
      if (this.smsType == "3" && this.formData.type == "2") {
        if (
          !this.uploadObj ||
          !this.uploadObj.fid ||
          !this.uploadObj.totalMobile
        ) {
          this.$message.warning("还没有可以发送的手机号码哦 ！");
          return;
        }
      }

      // 官方发送人数不能少于2
      if (
        this.sendPeopleNum < 2 &&
        (this.smsType == "1" || this.smsType == "2")
      ) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数~");
        return;
      }
      var timestamp = new Date().getTime();
      var date = new Date(sendTime1 + " " + sendTime2).getTime();
      if (timestamp > date) {
        this.$message.error("发送时间小于当前时间，请重新选择");
        return;
      }

      if(this.formData.smsType == 2 && this.failBackConfig.failBackType == 1){
        const checkFailResult = await this.$wordCheck({ content: this.failBackConfig.content })
        if (checkFailResult.code != 1) {
          return this.$message.error(checkFailResult.message)
        }
      }


      // 敏感词检测
      const checkResult = await this.$wordCheck({ content: this.formData.content })
      if (checkResult.code != 1) {
        return this.$message.error(checkResult.message)
      }

      this.isTestSend = false; // 表示提交发送
      this.showSendConfirm = true;
    },

    // 确认发送弹窗确认按钮
    handleSendConfirm() {
      this.showSendConfirm = false;
      if (this.isTestSend) {
        // 测试发送
        this.preCommitTest();
      } else {
        // 提交发送
        if (this.sendType == "1") {
          // 精选营销发送
          this.isEdit = false;//状态修改为新建状态
          this.editId = ''
          postSmsType(this.formData.smsType).then((res)=>{
            if (res.code == "1") {
              // this.$message.success("已一键清空!");
            } else {
              this.$message.error(res.message);
            }
          })
          this.officialSend();
        } else if (this.sendType == "2") {
          // 会员发送
          // this.preCommitSend(true);
          this.handleSendPlatform(2);
        } else if (this.sendType == "3" || this.sendType == "15") {
          // 订单发送
          this.handleSendPlatform(2);
        } else if (this.sendType == "4" || this.sendType == "5") {
          // 指定号码发送
          this.preCommitSend(true);
        }
      }
    },

    // 测试短信的预发送
    preCommitTest() {
      // dataFrom  数据来源类型 0 测试短信 1 会员发送 2 订单发送 4 输入号码发送 5 指定号码发送 6 变量短信发送 7 手动催评 8 手动回评 9 手动审核退款 10 营销汇总分析发送
      // sendType定义 （根据实际情况传参）：1 按条件查询 2 勾选 3 按会员分组 0 其他
      var mobiles = this.mobiles.split(",");
      this.phoneLenght = mobiles.length;

      console.log("mobiles:", mobiles);
      // var mobiles = this.mobiles.join(',');
      var dataFrom = 0;
      var sendType = 0;
      var smsType = 0
      if (this.sendType == 2) {
        // 会员发送
        sendType = this.preSendType;
      }

      var param = {
        dataFrom,
        sendType,
        mobiles,
        smsType
      };
      if (this.signature == 2) {
        param.orderType = 99;
      }

      // preCommit(param).then((res) => {
      // console.log("原始参数",param)
      let postData = {
        content: this.formData.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: param.mobiles.join(','),
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          // if (this.isTestSend) {
          //   this.preTestData.sendObjectCount = res.data.sendObjectCount;
          //   this.preTestData.sendObjectId = res.data.sendObjectId;
          // } else {
          //   this.preData.sendObjectCount = res.data.sendObjectCount;
          //   this.preData.sendObjectId = res.data.sendObjectId;
          // }
          this.$message.success(res.data);
          // this.handleSendPlatform(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 提交发送的预提交 flag = true, 发送短信接口，false 只是调用预提交接口
    preCommitSend(flag) {
      // dataFrom  数据来源类型 0 测试短信 1 会员发送 2 订单发送 4 输入号码发送 5 指定号码发送 6 变量短信发送 7 手动催评 8 手动回评 9 手动审核退款 10 营销汇总分析发送
      // sendType定义 （根据实际情况传参）：1 按条件查询 2 勾选 3 按会员分组 0 其他

      var dataFrom = 1;
      var sendType = this.preSendType;
      if (this.sendType == 2) {
        // 会员发送
        dataFrom = 1;
      } else if (this.sendType == 3) {
        // 订单发送
        dataFrom = 2;
      } else if (this.sendType == 4) {
        // 指定号码发送
        if (this.formData.type == 2) {
          // 导入号码发送
          dataFrom = 5;
          sendType = 0;
        } else {
          // 输入号码发送
          dataFrom = 4;
          sendType = 0;
        }
      } else if (this.sendType == 5) {
        // 变量短信发送
        dataFrom = 6;
        sendType = 0;
      } else if (this.sendType == 15) {
        // 预售订单
        dataFrom = 15;
      }

      var param = {
        dataFrom,
        sendType,
      };

      if (this.sendType == 2 || this.sendType == 3 || this.sendType == 15) {
        if (this.isEffectSend) {
          // 效果分析跳转过来的
          if (this.effectParam.taskId) {
            // 官方汇总分析跳转过来的
            param = {
              dataFrom: 10,
              sendType: 0,
              taskId: this.effectParam.taskId,
              sendObjectType: this.effectRadio,
            };
          } else {
            // 官方批次跳转过来的
            param = {
              dataFrom: 12,
              sendType: 0,
              bid: this.effectParam.bid,
              smsType: this.effectParam.isOfficial ? "1" : "0", // 会员发送，订单发送 官方需传1，其他的传0
              sendObjectType: this.effectRadio,
            };
          }
        } else {
          Object.assign(param, this.conditionParam);
        }
      } else if (this.sendType == 4) {
        // 指定号码发送
        if (this.formData.type == "2") {
          // 上传手机号
          param.fileId = this.uploadObj.fid;
        } else {
          var inputMobileStr = this.formData.inputMobileStr;
          var list = [];
          if (inputMobileStr.indexOf(",") != "-1") {
            list = inputMobileStr.split(",");
          } else {
            list = [inputMobileStr];
          }
          param.mobile = list;
        }

        if (this.isEffectSend) {
          // 营销效果的发送短信
          param = {
            dataFrom: 11,
            sendType: 0,
            bid: this.effectParam.bid,
            sendObjectType: this.effectRadio,
          };
        }
      } else if (this.sendType == 5) {
        param.fileId = this.uploadObj.fid;
      }

      console.log("param", param);
      if (this.signature == 2) {
        param.orderType = 99;
      }
      // 预提交发送
      this.preLoading = true;
      preCommit(param).then((res) => {
      // console.log("原始参数",param)
      // let postData = {
      //   content: this.formData.content+'拒收请回复R',
      //   // jdSmsSuffix: this.formData.jdSmsSuffix,
      //   mobile: param.mobiles[0],
      // }
      // 短信测试新接口
      // NewPreCommit(postData).then((res) => {
        this.preLoading = false;
        if (res.code == "1") {
          this.preData.sendObjectCount = res.data.sendObjectCount;
          this.preData.sendObjectId = res.data.sendObjectId;

          this.sendPeopleNum = res.data.sendObjectCount;
          if (flag) {
            this.handleSendPlatform(2);
          }
          // this.$message.success(res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 平台发送短信接口调用 type: 1,表示测试短信发送， 2.表示提交发送
    handleSendPlatform(type) {
      var param = null;
      var sendObjectId = this.preData.sendObjectId;
      if (type == "1") {
        console.log(2222);
        sendObjectId = this.preTestData.sendObjectId;
        // 测试短信的发送
        param = {
          content: this.formData.content + this.TTip,
          sendObjectId,
          smsSuffix: this.formData.jdSmsSuffix,
          blackFlag: false,
          smsType:0
        };
      } else if (type == "2") {
        console.log(1111);
        // this.timeChangeOne();
        // return;
        // 提交发送
        var sendTime = this.formData.sendTime1 + " " + this.formData.sendTime2;
        var activityTitle = this.formData.activityTitle;
        if( this.formData.smsType == 0 ){
          var content = this.formData.content + this.TTip;
        }else{
          var content = this.formData.content;
        }
        var jdShortLink = this.formData.jdShortLink;
        var url = this.formData.url;
        var jdSmsSuffix = this.formData.jdSmsSuffix;
        var fitlerDay = this.formData.fitlerDay; // 过滤天数
        var blackFlag = this.formData.blackFlag == true ? true : false;
        var badReviewFilterSetting =
          this.formData.badReviewFilterSetting == true ? true : false;
        var refundFilterSetting =
          this.formData.refundFilterSetting == true ? true : false;
        var allMobile = this.formData.allMobile; // 手机号码段是否全选
        var mobileTypes = this.formData.mobileTypes; // 手机号码段
        var jmlIds = this.formData.jmlIds; // 悦信短网址链接id列表
        var mySendType = this.formData.mySendType; // 立即发送 1.定时发送
        var smsType = this.formData.smsType;
        var mediaTestMobiles = this.formData.mediaTestMobiles;
        var mediaTitle = this.formData.mediaTitle;
        var mediaList = this.formData.mediaList;
        var sourceUrl = ''
        if(this.formData.smsType == 1){
        jdShortLink = this.richMessageData.jdShortLink;
        url = this.richMessageData.sourceUrl
      }

        if (allMobile) {
          mobileTypes = "1,2,3";
        } else {
          mobileTypes = mobileTypes.join(",");
        }

        if (fitlerDay == "-1") {
          fitlerDay = this.formData.fitlerDayNum;
        }

        if (this.sendType == 2 || this.sendType == 3 || this.sendType == 15) {
          // 会员发送 订单发送
          param = {
            title: activityTitle,
            content,
            jdShortLink,
            url,
            smsSuffix: jdSmsSuffix,
            fitlerDay,
            sendTime,
            badReviewFilterSetting,
            refundFilterSetting,
            sendObjectId,
            blackFlag,
            smsType,
            mediaTestMobiles,
            mediaTitle,
            mediaList,
            sourceUrl,
            mediaTemplateId:this.mediaTemplateId
          };
        } else if (this.sendType == "4" || this.sendType == "5") {
          // 指定号码发送
          param = {
            title: activityTitle,
            content,
            jmlIds,
            smsSuffix: "【" + jdSmsSuffix + "】",
            fitlerDay,
            mobileTypes,
            sendObjectId,
            blackFlag,
          };
          if (mySendType == "1") {
            param.sendTime = sendTime;
          }
        }
      }
      if(this.formData.smsType == 2 ){
        param.failBackConfig = this.failBackConfig
        if(param.failBackConfig.failBackType == 1){
          param.failBackConfig.content += this.TTip;
        }
      }
      console.log("param1---:", param);
      platformSend(param).then((res) => {
        if (res.code == "1") {
          if (type == "2") {
            this.successDialog = true;
          } else {
            this.$message.success("发送成功");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.mobiles = this.Selectmobiles.join(',')
    },
    // 精选营销提交发送 （官方）
    officialSend() {
      var sendTime = this.formData.sendTime1 + " " + this.formData.sendTime2;
      var activityTitle = this.formData.activityTitle;
      var content;
      if( this.formData.smsType == 0 ){
        content = this.formData.content + this.TTip;
      }else if(this.formData.smsType == 2 ){
        content = this.formData.content + this.TTip;
      }else{
        content = this.formData.content;
      }
      var jdShortLink = this.formData.jdShortLink;
      var jdSmsSuffix = this.formData.jdSmsSuffix;
      var sendSubmitNum = this.formData.sendOutIpt;
      var strategyInstId = this.computeData.strategyInstId;
      var sendSubmitNumType = this.formData.sendIntType;
      var sourceUrl = this.sourceUrl;
      var smsType = this.formData.smsType;
      var mediaTestMobiles = this.formData.mediaTestMobiles;
      var mediaTitle = this.formData.mediaTitle;
      var mediaList = this.formData.mediaList;
      if(this.formData.smsType == 1){
        jdShortLink = this.richMessageData.jdShortLink;
        sourceUrl = this.richMessageData.sourceUrl
      }
      if (this.formData.sendIntType == "0") {
        // 不限制发送人数
        sendSubmitNum = this.sendPeopleNum;
      }
      

      var param = {
        activityTitle,
        content,
        jdShortLink,
        jdSmsSuffix,
        sendSubmitNum,
        sendSubmitNumType,
        sendTime,
        strategyInstId,
        sourceUrl,
        smsType,
        mediaTestMobiles,
        mediaTitle,
        mediaList,
        mediaTemplateId:this.mediaTemplateId
      };
      if(this.formData.smsType == 2 ){
        param.failBackConfig = this.failBackConfig
        if(param.failBackConfig.failBackType == 1){
          param.failBackConfig.content += this.TTip;
        }
      }
      console.log(param);
      precisionMarketing(param).then((res) => {
        if (res.code == "1") {
          // this.$message.success('发送成功！');
          this.successDialog = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 获取短信余额
    getSmsBalance() {
      getSellerInfo().then((res) => {
        if (res.code == "1") {
          console.log(res);
          var paySmsTotal = res.data.paySmsTotal;
          var useSmsTotal = res.data.useSmsTotal;

          if (paySmsTotal) {
            this.balance = useSmsTotal
              ? paySmsTotal - useSmsTotal
              : paySmsTotal;
          }
        }
      });
    },

    switchSuffix(index) {
      this.selectSuffix = this.suffixList[index];
      this.formData.jdSmsSuffix = this.selectSuffix || "";
      this.richMessageData.jdSmsSuffix = this.selectSuffix || ""
      // console.log( this.switchSuffix)
    },

    // 获取官方和系统的的短信签名
    getOfficialSuffix() {
      // 1.系统 2.京东官方签名
      var type = 2;
      if (this.smsType == "1" || this.smsType == "2") {
        type = 2;
      } else {
        type = 1;
      }

      getPrecisionJdSuffixList(type).then((res) => {
        if (res.code == "1") {
          var suffixList = res.data;
          this.suffixList = suffixList;
          this.selectSuffix = suffixList[0];
          this.formData.jdSmsSuffix = this.selectSuffix || "";
          this.richMessageData.jdSmsSuffix = this.selectSuffix || ""
          this.returnData.jdSmsSuffix = this.selectSuffix || ""

          // for (var i = 0; i<suffixList.length; i++ ) {
          //   if (suffixList[i].signStatusName == '生效中') {
          //     this.selectSuffix = suffixList[i];
          //     this.formData.jdSmsSuffix = this.selectSuffix.jdSmsSuffix;
          //     break;
          //   }
          // }
        }
      });
    },

    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      if(this.formData.smsType == 2 && this.failBackConfig.failBackType == 1){
        if (!val) {
          return;
        }
        this.failBackConfig.content += " " + obj.shortLink + " ",
        this.failBackConfig.jdShortLink = obj.shortLink,
        this.failBackConfig.realUrl = obj.originUrl;
        return;
    }
      if (val) {
        this.sourceUrl = obj.originUrl;
        // 自家平台的短链接可以叠加
        // this.insertShortUrl = url;
        if (this.smsType != "3") {
          // 官方短链接
          this.formData.jdShortLink = obj.shortLink;
          this.jdShortLinkList.push(obj);
        } else {
          // 平台
          this.formData.jmlIds.push(obj.id);
        }
        this.formData.content =
          this.formData.content + " " + obj.shortLink + " ";
      }
    },
    /** 选择人群相关的方法  */
    delPeople(type, index) {
      if (this.computeLoading) {
        return;
      }
      if (type == "0") {
        this.includePeople.splice(index, 1);
      } else if (type == "1") {
        this.excludePeople.splice(index, 1);
      }
    },
    // 显示选择人群弹窗
    showPeopleDialog(type) {
      this.peopleType = type;
      console.log(1213, this.includePeople);
      if (type == "0") {
        this.showSelectPeople = this.includePeople;
      } else if (type == "1") {
        this.showSelectPeople = this.excludePeople;
      }

      this.selectPeopleDialog = true;
    },

    // 返回选择的人群
    handleSelectPeople(obj) {
      console.log(obj);
      this.selectPeopleDialog = false;
      if (this.peopleType == "0") {
        // 包含人群
        this.includePeople = obj;
      } else if (this.peopleType == "1") {
        // 排除人群
        this.excludePeople = obj;
      }
    },
    // 取消选择人群
    canclePeople() {
      this.selectPeopleDialog = false;
    },
    /**  end */

    filterCondiions() { },
    handleShowInputPhone() {
      this.showPhoneDialog = true;
    },
    routerLinkOne() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
        // hash: "#/memberlist/memberblack",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 下一步
    nextStep() {
      this.sendStep = 2;
    },
    // 上一步
    lastStep() {
      if (this.sendType == "1") {
        this.sendStep = 1;
      } else if (this.sendType == "2") {
        this.$emit("lastStep");
      }
    },
    filNumber() { },
    sendConditionTips() { },
    moneyPayTimeChange() { },
    clearTime() { },
    // 跳转至设置黑名单页面

    // 京东跳转App链接隐藏
    jdJumpLinkChange(val) {
      this.jdJumpLinkShow = false;
      // 生成网址
      if (val == 1) {
      }
    },
    // 插入优惠券隐藏
    // insertCouponChange(val, item) {
    //   this.insertCouponShow = false;
    //   console.log("插入优惠劵返回==", val, item);
    //   if (val == true) {
    //   }
    // },
    // 插入短链接隐藏
    // insertUrlChange(val) {
    //   this.insertShortUrlShow = false;
    //   // 生成网址
    //   if (val == 1) {
    //   }
    // },
    handleShowModule() {
      // 保存模板 显示
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
          this.keepTmpShow = true;
        }
      });
    },
    // 保存模板
    savaTemplate() {
      this.keepTmpShow = false;
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.formData.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 创建人群
    toCreatePeople() {
      let routeUrl = this.$router.resolve({
        path: "/marketing",
        // query: { to: "/marketing/marketing/member_grouping" }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 选择人群
    // selectCrowd(_item) {
    //   this.selectPeopleDialog = false;
    //   this.selCrowdName = _item.crowdName;
    //   this.selCrowdNum = _item.crowdNum;
    // },
    /* 
      选择人群-分页事件
    */
    // handleSizeChange(val) {
    //   this.smsSearchParams.pageSize = val;
    //   // this.backTolist();
    // },
    // handleCurrentChange(val) {
    //   this.smsSearchParams.pageNum = val;
    //   // this.backTolist();
    // },
    // 得到当前时间
    getNowDate(_val) {
      var date = new Date();
      var seperator1 = "";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;
      var currentdate2 =
        date.getFullYear() +
        "-" +
        seperator1 +
        month +
        "-" +
        seperator1 +
        strDate;
      var currentdate3 =
        date.getFullYear() +
        "-" +
        seperator1 +
        month +
        "-" +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;
      if (_val == 2) {
        return currentdate2;
      }else if(_val == 3){
        console.log("时间",currentdate3)
        return currentdate3;
      } else {
        return currentdate;
      }
    },
    getNowDate2() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      date.setMinutes(date.getMinutes() + 10);
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }

      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;

      return currentdate;
    },
    // 短信模板隐藏
    templateChange(val, item) {
      this.templateShow = false;
      console.log("模版选择返回==", val, item);
      if (val == true) {
        if(this.formData.smsType == 2 && this.failBackConfig.failBackType == 1){
          this.failBackConfig.content = item.content;
          this.failBackConfig.jdShortLink = "";
          this.failBackConfig.realUrl = "";
        }else{
          this.selectTemplate = item;
          // this.formData.content = this.formData.content + item.content;
          this.formData.jdShortLink = "";
          this.formData.content = item.content;
        }
      }
    },
    // 不可输入小数
    oninput(val) {
      return val ? val.replace(/\D/g, "") : "";
    },
    // 发送人数的限制
    sendPeopleChange(val) {
      if (val == 0) {
        this.formData.sendOutIpt = "";
        this.$message.warning("人数只能输入正整数");
      } else if (this.sendPeopleNum && val >= this.sendPeopleNum) {
        this.formData.sendOutIpt = "";
        this.$message.warning("限制人数必须小于当前人群数量");
      }
    },
    // 短信测试的校验
    phoneTest(val) {
      var reg = /[^\d,，\s]/g,
        mobiles = val;
      if (reg.test(mobiles)) {
        mobiles = mobiles.replace(reg, "");
      }
      this.mobiles = mobiles;
    },
    // 短信记录的返回
    shortBtnTwo2(data) {
      this.smsState2 = !this.smsState2;
    },
    //
    handleTime() {
      var startAt = (new Date(this.formData.sendTime) * 1000) / 1000;
      // if(startAt < Date.now()) {
      //     // this.formData.sendTime = new Date();
      //     this.formData.sendTime = this.getNowDate(2);
      //     console.log(this.getNowDate(2));
      //     console.log(this.formData.sendTime);
      // }
    },
    // 富信测试手机号 
    selectMediaTestMobiles(val) {
      this.formData.mediaTestMobiles = this.mediaTestMobilesList.join(',')
      console.log(this.formData.mediaTestMobiles);
    },
    // 选择模板 打开
    selectTempleteShow() {
      this.tableLoading = true
      this.selectTempleteShowDialog = true
      let params = {
        size: this.templatePaginationInfo.size,
        current: this.templatePaginationInfo.current
      }
      getSmsMediaTemplate(params).then(res => {
        if(res.code == 1){
          this.templatePaginationInfo.total = res.data.total
          this.selectTemplateData = res.data.records
          this.tableLoading = false
        }
      })
    },
    // 选择模板 关闭
    chooseTemplate(val,close) {
      if(close == 1){
        this.selectTempleteShowDialog = false
        return
      } 
      getSmsMediaTemplateDetail(val.id).then(res => {
        if (res.code == 1) {
          let data = res.data
          this.returnData.mediaTitle = data.title
          this.returnData.totalSize = data.totalSize
          this.returnData.content = data.text
          this.returnData.mediaList = data.mediaList
          this.returnData.sourceUrl = data.originUrl
          // 模板名称
          this.richtemplateName = data.name
          this.selectTempleteShowDialog = false
        }
      })
    },
    // 选择模板分页器
    handleTemplateCurrentChange(val) {
      this.templatePaginationInfo.current = val
      this.selectTempleteShow()
    },
    // 选择模板分页器
    handleSizeChange(val) {
      this.templatePaginationInfo.size = val
      this.selectTempleteShow()
    },
    // 查看短信内容
    showTemplateInfo(val) {
      getSmsMediaTemplateDetail(val.id).then(res => {
        if (res.code == 1) {
          this.smsInfoRowData = res.data
          this.smsInfoRowData.contentId = val.mediaMulitiFileId
          this.smsInfoShow = true
        }
      })
    },
    // 关闭短信内容弹窗
    handleCloseSmsInfo() {
      this.smsInfoShow = false
    },
    // 保存模板 显示
    handleShowModule1() {
      this.richkeepTmpShow = true;
    },
    // 保存模板隐藏
    handleCloseTmp(val) {
      if (val == 1 ) {
        // if(!this.richtemplateName){
        //   this.$message({ message: '请输入模板名称', type: 'warning' });
        //   return false
        // }
        if(!this.richMessageData.mediaTitle){
          this.$message({ message: '请输入富信标题', type: 'warning' });
          return false
        }
        // if(!this.richMessageData.content){
        //   this.$message({ message: '请输入富信内容', type: 'warning' });
        //   return false
        // }
        // if (!this.richMessageData.sourceUrl) {
        //   this.$message({ message: '请插入短链接', type: 'warning' });
        //   return false
        // }
        let params = {
          name: this.richtemplateName,
          title: this.richMessageData.mediaTitle,
          text: this.richMessageData.content,
          originUrl: this.richMessageData.sourceUrl,
          mediaList: this.richMessageData.mediaList,
          totalSize: this.richMessageData.totalSize
        }
        smsMediaTemplateSave(params).then((res) => {
          if (res.code == "1") {
            this.$message.success({message:"保存模板成功！",customClass:'message-zindex'});
            this.richkeepTmpShow = false
          } else {
            this.$message.error({message:res.message,customClass:'message-zindex'});
          }
        })
      }else{
        this.richkeepTmpShow = false;
      }
    },
    // 修改测试手机号弹窗
    updataPhone() {
      this.showDialogOne = true
    },
    // 修改测试手机号确认弹窗
    mobilPhoneSubmit() {
      updateSuffixMobileById({
        smsTestMobiles: this.testMobiles,
        id: this.textPhoneId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.formData.mediaTestMobiles = ''
            this.mediaTestMobilesList = [];
            this.getVal();
            this.showDialogOne = false
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    dateChange(val) {
      var nowTime10 = this.getNowDate2();
      var time1 = nowTime10.substring(0, 10);
      var time2 = nowTime10.substring(11, 19);
      var startTime = this.limitTime.startTime;
      var endTime = this.limitTime.endTime;
      // var time2 = "20:58:59";
      var arr = time2.split(":");
      var endArr = endTime.split(":");

      // 最晚可以选到时间
      if (arr[0] > endArr[0]) {
        time2 = endTime;
      } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
        time2 = endTime;
      } else if (
        arr[0] == endArr[0] &&
        arr[1] == endArr[1] &&
        arr[2] >= endArr[2]
      ) {
        time2 = endTime;
      }

      // 选择时间为空
      this.formData.sendTime2 = "";

      if (val == time1) {
        this.expireTimeOption2.selectableRange = time2 + " - " + endTime;
      } else {
        this.expireTimeOption2.selectableRange = startTime + " - " + endTime;
      }
    },
    timeChange(val) { },
    //定时发送时间判断
    timeChangeOne(val) {
      // console.log(val);
      if (val == null) {
        this.formData.sendTime2 = "";
      } else {
        let year = new Date().getFullYear();
        let month =
          new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1;
        let date =
          new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate();
        let hh =
          new Date().getHours() < 10
            ? "0" + new Date().getHours()
            : new Date().getHours();
        let mm =
          new Date().getMinutes() < 10
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes();
        let ss =
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds();
        if (this.formData.sendTime1 != "" && this.formData.sendTime2 != "") {
          let path = this.formData.sendTime1.split("-");
          let path1 = this.formData.sendTime2.split(":");
          if (year == path[0] && month == path[1] && date == path[2]) {
            let now = parseInt(hh) * 3600 + parseInt(mm) * 60 + parseInt(ss);
            let end =
              parseInt(path1[0]) * 3600 +
              parseInt(path1[1]) * 60 +
              parseInt(path1[2]);
            if (now >= end) {
              this.$message.warning("不能选择过去时间");
              this.formData.sendTime2 = "";
            }
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}
.notShow {
  position: relative;

  img {
    margin-left: 100px;
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    left: 197px;
    top: 328px;
    color: #999999;
    font-size: 14px;
  }

  .bottom-btn {
    width: 560px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .select {
  width: 98px;
  height: 32px;
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fff4f4;

  &:hover {
    color: #fe4d45;
    background-color: #ffe5e5;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
}
.btnListButtom {
        color: rgb(127, 133, 233);

        &:hover {
          color: #fe4d45;
        }
      }
.activityTip {
  color: #fe4d45;
  padding-left: 93px;
}

/deep/ .self-style .el-form-item__label {
  padding-top: 15px;
}

/deep/.pickerChange .el-icon-date:before {
  content: "\E78E";
  position: absolute;
  left: 107px;
}

/deep/.pickerChange1 .el-icon-time:before {
  content: "\E71F";
  position: absolute;
  left: 107px;
}

/deep/ #select-header-color .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #333;
}

// /deep/ .spanClan {.tip-box-global {
//     padding-left: 24px;
//     text-align: left;
//     line-height: 21px;
//     font-size: 13px;
//     margin-top: 12px;
//     color: #999999;
//     width: 100%;
//     background: #FFFAEE;
//     margin: 20px 0 16px -13px;
//     line-height: 10px !important;
// }}
.variable-list {
  font-size: 0;

  .variable-item {
    font-size: 14px;
    display: inline-block;
    height: 20px;
    line-height: 20px;
    border-radius: 0px;
    cursor: pointer;
    margin-bottom: 2px;
    color: #fff;
    margin-right: 5px;
    padding: 0 6px;
    vertical-align: bottom;
  }
}

.nav-box {
  height: 54px;
  line-height: 54px;

  // border-bottom: 1px solid #f0f0f0;
  // padding-left: 27px;
  .go-back {
    font-size: 14px;
    color: #999999;
    vertical-align: middle;
    cursor: pointer;
  }
}

/* 发送确认弹窗 */
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;

    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}

/** end */
/** 步骤条 */
.step-bar {
  // background: #fafafa;
  position: relative;
  padding-left: 12px;
  margin-left: 29px;
  margin-bottom: 20px;
  width: -webkit-calc(100% - 80px);
  width: -moz-calc(100% - 80px);
  width: calc(100% - 80px);

  .serial {
    width: 22px;
    height: 22px;
    border-radius: 22px;
    color: #fff;
    line-height: 22px;
    text-align: center;
    display: inline-block;
    line-height: 22px;
    position: absolute;
    left: -29px;
    top: 50%;
    transform: translateY(-50%);
  }

  .division {
    display: inline-block;
    width: 3px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
  }

  .name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 32px;
    vertical-align: middle;
  }
}

.import-box {

  // display: inline-block;
  // width: 562px;
  // vertical-align: top;
  .top-import {
    padding: 16px 0 16px 16px;
    position: relative;
    border: 1px solid #eeeeee;

    .upload-btn {
      height: 28px;
      width: 96px;
      border: 1px solid #cccccc;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 16px;
    }

    .num {
      color: #fe4d45;
    }

    .upload-num {
      position: absolute;
      top: 17px;
      right: 16px;
    }
  }

  .tip-box {
    background-color: #fafafa;
    padding: 12px 34px;
    position: relative;

    .icon-waring {
      color: #fe8f8a;
      font-size: 14px;
      position: absolute;
      left: 10px;
      top: 15px;
    }

    p {
      font-size: 13px;
      line-height: 20px;
      margin: 0;
      padding: 0;
    }
  }
}

.height-num-x {
  padding: 0 8px;
}

.setting-black {
  color: #7f85e9;
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    color: #fe4d45;
  }
}

.step-line {
  text-align: center;
  padding: 44px 0;
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 24px;

  .step-item {
    color: #999999;
    vertical-align: middle;
    display: inline-block;

    .step-num {
      display: inline-block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      border-radius: 24px;
      border: 1px solid #cccccc;
      margin-right: 8px;
    }

    .step-text {
      font-size: 16px;
    }

    &.active {
      .step-text {
        font-weight: 500;
        color: #333;
      }

      .step-num {
        background: linear-gradient(180deg,
            rgba(255, 109, 110, 1) 0%,
            rgba(254, 51, 59, 1) 100%);
        border-radius: 50%;
        border-color: #fe333b;
        color: #fff;
      }
    }
  }

  .step-division {
    display: inline-block;
    width: 240px;
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
    vertical-align: middle;
    margin: 0 8px;
  }
}

.next-line {
  text-align: center;
  position: relative;

  // padding: 32px 24px;
  // padding-top: 25px;
  // border-top: 1px solid #F6F6F6;
  // margin-top: 200px;
  .compute-people {
    position: absolute;
    font-size: 14px;
    color: #333;

    .item-name {
      width: 162px;
      display: inline-block;
    }

    .handleCaculateButtom {
      width: 98px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      border-radius: 3px;
      background-color: #fff4f4;

      &:hover {
        color: #fe4d45;
        background-color: #ffe5e5;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .el-button {
      margin-right: 12px;
    }

    .height-num {
      padding: 0 8px;
    }

    .el-button {
      margin-left: 12px;
    }
  }

  .btn-group {
    width: 188px;
    height: 36px;
  }
}

// 第一步筛选人群
.step1-box {
  font-size: 14px;
  color: #333;
  width: 1666px;

  // margin-top: 86px;
  .form-item {
    margin-bottom: 16px;

    &>div {
      display: inline-block;
    }

    .item-label {
      width: 154px;
      text-align: right;
      padding-right: 8px;
      box-sizing: border-box;
      vertical-align: text-top;
      line-height: 32px;
    }

    .item-value {
      width: 902px;
      vertical-align: text-top;

      .select-people-box {
        .select-header {
          @media screen and (max-width: 1366px) {
            width: 800px;
          }

          background: #f6f6f6;
          position: relative;
          padding: 8px;

          .computeLoadingButtom {
            width: 98px;
            height: 28px;
            color: #fe4d45;
            border-radius: 3px;
            border: 1px solid #fe4d45;
            background-color: #fff;

            &:hover {
              color: #fff;
              border: 1px solid #fff;
              background-color: #fe4d45;
            }

            &:active {
              color: #fff;
              border: 1px solid #fff;
              background-color: #fe4d45;
            }
          }

          .height-num {
            color: #7f85e9;
            margin: 0 4px;
          }

          .operation-wrapper {
            position: absolute;
            right: 20px;
            transform: translateY(-50%);
            top: 50%;
          }
        }

        .people-group {
          border: 1px solid rgba(246, 246, 246, 1);
          color: #999;
          padding-top: 14px;

          // margin-bottom: 20px;
          .group-item {
            // padding: 14px 12px;
            position: relative;
            display: inline-block;
            line-height: 32px;
            height: 32px;
            border: 1px solid rgba(238, 238, 238, 1);
            border-radius: 2px;
            color: #666666;
            margin-left: 10px;
            margin-bottom: 14px;
            position: relative;

            // &.group-item:nth-child(4n){
            //   margin-right: 0;
            // }
            .group-name {
              // width: 210px;
              display: inline-block;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
              overflow: hidden;
              // border:1px solid #CCCCCC;
              padding: 0 12px;
            }

            .close {
              display: none;
              position: absolute;
              right: -6px;
              top: -6px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              cursor: pointer;
              background-color: #fe4d45;

              // display: none;
              &:before,
              &:after {
                position: absolute;
                top: 4px;
                left: 7px;
                content: " ";
                height: 8px;
                width: 2px;
                background-color: #fff;
              }

              &:before {
                transform: rotate(45deg);
              }

              &:after {
                transform: rotate(-45deg);
              }
            }

            &:hover .close {
              display: inline-block;
            }
          }
        }
      }
    }

    .activity-theme {
      .el-input {
        @media screen and (max-width: 1366px) {
          width: 800px;
        }
      }
    }
  }
}

// 第一步筛选人群 end

// 选择人群弹窗
.select-people-dialog {
  .dialog-title {
    span {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;

      .el-button {
        font-size: 14px;
      }
    }
  }

  .search-line {
    margin-bottom: 24px;

    .el-input {
      width: 280px;
      margin-right: 20px;
    }
  }
}

// 选择人群弹窗 end
.accurate_market {
  .main_content {
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    opacity: 1;
    border-radius: 6px;
    margin: 20px 20px 28px;
    padding: 0 20px;
    // padding-top: 30px;
    color: #333;

    @media screen and (max-width: 1366px) {
      margin: 20px 0 28px 20px;
      padding: 0 0 0 20px;
    }

    .main_content_top {
      padding: 20px 0 65px 0;
      position: relative;
    }

    .topTis {
      margin: 20px 28px 0 28px;
      // display: flex;
      // align-items: baseline;
      position: relative;
      color: #333333;
      font-size: 14px;
      background: #FFFAEE;
      opacity: 1;
      padding: 12px;

    .desc {
      line-height: 20px;

      .setting-text {
        margin-bottom: 8px;

        span {
          font-size: 14px;
          color: #7f85e9;
          margin-left: 30px;
          cursor: pointer;

          &:hover {
            color: #fe4d45 !important;
          }
        }
      }

      .count {
        font-weight: bold;
        color: red;
      }
    }

    p {
      margin: 0px;
      line-height: 20px;
      // width: 700px;
    }
  }

    .textarea {
      box-sizing: border-box;
      padding: 6px 6px 10px;
      width: 100%;
      background: rgba(249, 250, 251, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 2px;

      .footInfo {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        font-size: 14px;
        color: #333;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 76px;
          height: 28px;
          outline: none;
          border: none;
          background-color: white;
          border-radius: 2px;
          font-size: 13px;
        }

        div {
          display: flex;
          align-items: center;
        }

        .select {
          cursor: pointer;
          color: #fe4d45;
          border: 1px solid #fe4d45;
          border-radius: 3px;
          background-color: #fff4f4;

          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }

          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }

        .keep {
          margin: 0 10px 0 8px;
          cursor: pointer;
          color: #ffffff;
          border-radius: 3px;
          border: 1px solid #fe4d45;
          background-color: #fe4d45;

          &:hover {
            color: #fff;
            opacity: 0.9;
            background-color: #fe4d45;
          }

          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
    }

    .footTips {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-top: 8px;
      padding-left: 12px;
      height: 28px;
      background: rgba(255, 250, 238, 1);
      border: 1px solid rgba(255, 185, 94, 1);
      border-radius: 2px;
      color: #333;
      font-size: 13px;
    }

    .select_people {
      // width: 98px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 2px;
      display: inline-block;
      text-align: center;
      line-height: 30px;
      margin-right: 12px;
      cursor: pointer;
      padding: 0 20px;
    }

    .create_people {
      width: 98px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      opacity: 1;
      border-radius: 2px;
      display: inline-block;
      text-align: center;
      line-height: 30px;
      color: #999;
      cursor: pointer;
    }

    .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      margin-left: 8px;

      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }

    .ask_content {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      margin-right: 2px;
      cursor: pointer;

      .ask-icon {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        position: relative;
      }

      .contentButtom {
        color: #7f85e9;

        &:hover {
          color: #fe4d45;
        }
      }

      .ask-icon-select {
        position: absolute;
        bottom: 38px;
        margin-left: -133px;
        display: none !important;
        width: 375px;
        // height: 80px;
        line-height: 20px;
        padding: 20px;
        background-color: #fff;
        text-align: left;
        box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
        color: #999999;
        z-index: 1;
      }

      .ask-icon-select:before {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        right: 50%;
        margin-left: -4px;
        top: 100%;
        border-left: 8px solid transparent;
        border-top: 8px solid #fff;
        border-right: 8px solid transparent;
      }
    }

    .ask_content:hover {
      .ask-icon-select {
        display: block !important;
      }
    }

    .btnList {

      // display: flex;
      // align-items: center;
      // height: 32px;
      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        cursor: pointer;
      }

      .replaceButtom {
        cursor: pointer;
        color: rgb(127, 133, 233);

        &:hover {
          color: #fe4d45;
        }
      }

      .btnBox {
        display: inline-block;
        position: relative;
        overflow: hidden;
        height: 32px;
        margin-right: 20px;

        .btn {
          width: 114px;
          height: 32px;
          color: #999999;
          border: 1px solid #cccccc;
          padding-left: 15px;
          border-radius: 3px;
          padding-right: 15px;
          cursor: pointer;
        }

        .check {
          position: absolute;
          right: -16px;
          bottom: -16px;
          width: 30px;
          height: 30px;
          // background-color: #FE4D45;
          border-radius: 50%;
        }

        i {
          position: absolute;
          right: 16px;
          bottom: 15px;
          font-size: 10px;
          color: #fff;
        }
      }
    }

    .tool {
      cursor: pointer;
      display: flex;
      align-items: center;

      p {
        box-sizing: border-box;
        padding: 0 8px;
        margin: 0 8px 0 0;
        // width: 98px;
        height: 32px;
        line-height: 28px;
        font-size: 14px;
        border-radius: 3px;
        background-color: #f7f8fe;
        border: 1px solid #7f85e9;
        color: #7f85e9;

        &:hover {
          background: rgba(174, 179, 241, 0.16);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9 !important;
        }

        &:active {
          background: rgba(174, 179, 241, 0.24);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9;
        }
      }
    }

    .test {
      font-size: 14px;

      // height: 32px;
      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        width: 98px;
        height: 32px;
        cursor: pointer;
      }

      .ipt {
        width: 224px;
        // margin: 0 0px 0 8px;
        vertical-align: top;
      }

      .sendTest {
        width: 106px;
        margin-left: 16px;
        padding: 5px 12px;
        border: 1px solid #fe4d45;
        background-color: #fff;
        color: #fe4d45;

        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45 !important;
        }

        &:active {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }

      .record {
        margin: 0 0px 0 8px;
        color: #333333;
        font-size: 14px;
        border-radius: 3px;
        border: 1px solid #cccccc;
        background-color: #fff;

        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }

        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }

      .record1 {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
        font-size: 14px;
        border-radius: 3px;
        width: 114px;
      }
    }

    .info {
      min-width: 900px;
      margin-top: 12px;
      line-height: 22px;
      font-size: 13px;
      color: #999;
      background: #FFFAEE;
      padding: 12px;
      color: #333;
      position: relative;

      p {
        margin: 0px;
        line-height: 25px;
        padding-left: 18px;
      }

      .warning-icon {
        color: #ffb95e;
        font-size: 16px;
        position: absolute;
        left: 10px;
        top: 18px;
      }
    }

    .foot {
      flex: 0 0 80px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      // padding-left: 28px;
      border-top: 1px solid #f0f0f0;
      flex-shrink: 0;
      height: 80px;
      line-height: 80px;

      .btn {
        line-height: 36px;
        margin-right: 24px;
        // background: rgba(254, 77, 69, 1);
        border-radius: 3px;
        cursor: pointer;

        // border: none;
        // outline: none;
        // color: #fff;
        @media screen and (max-width: 1366px) {
          margin-right: 0px;
          margin-left: 235px;
        }

        @media screen and (max-width: 1322px) {
          margin-right: 0px;
          margin-left: 180px;
        }

        width: 188px;
        height: 36px;
        font-size: 14px;
        font-weight: 500;
      }

      .txt {
        color: #333;
        font-size: 14px;
        margin-right: 20px;
        line-height: 20px;
        // .num { color: #FE4D45; }
      }
    }

    .mobile-box {
      position: relative;
      width: 256px;
      margin-top: 21px;
      height: 504px;

      // background: url("../../assets/images/mobileScreen.png") no-repeat;
      .message-content {
        position: absolute;
        word-wrap: break-word;
        max-height: 250px;
        overflow-y: auto;
        padding: 12px 12px;
        border-radius: 6px;
        width: 210px;
        font-size: 14px;
        background-color: #fafafa;
        line-height: 20px;
        left: 50%;
        margin-left: -104.665px;
        text-align: left;
        top: 25.4%;
      }
    }

    .mobile-tips {
      margin-top: 12px;
      font-size: 16px;
      text-align: center;
      color: rgba(51, 51, 51, 1);
    }
  }

  .xiao_hug2 {
    position: absolute;
    top: 50px;
    left: 1050px;
  }

  @media screen and (max-width: 1580px) {
    .xiao_hug2 {
      left: 950px;
    }
  }

  @media screen and (max-width: 1470px) {
    .xiao_hug2 {
      left: 865px;
    }
  }

  @media screen and (max-width: 1400px) {
    .xiao_hug2 {
      left: 815px;
    }
  }

  @media screen and (max-width: 1322px) {
    .xiao_hug2 {
      left: 755px;
    }
  }

  .selectBox {
    text-align: right;

    .headCnt {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }

    .keepBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }

    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }
  }

  .selectBox1 {
    text-align: right;

    .headCnt {
      width: 435px;
      margin: auto;
      display: flex;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 10px;
    }

    button {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }
  }

  .insertBox {
    text-align: right;

    .inser {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }

    .createUrlBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }

    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }

    .tip_box {
      text-align: left;
      line-height: 20px;
      margin-top: 10px;
      color: #fe4d45;
    }
  }

  .jumpLinkBox {
    .item {
      display: flex;
      align-items: center;
      margin-top: 20px;

      label {
        width: 80px;
        flex-shrink: 0;
        text-align: right;
        color: #333;
        font-size: 14px;
      }
    }

    .create {
      margin-top: 20px;
      text-align: right;

      .createBtn {
        border: none;
        width: 98px;
        height: 32px;
        line-height: 30px;
        background: rgba(254, 77, 69, 1);
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 3px;
        text-align: center;
        color: #fff;
      }
    }
  }
}

.aacc {
  display: flex;
  align-items: center;

  /deep/.el-checkbox {
    margin-right: 0 !important;
  }
}
.accurate_market {

  // form表单的单项
  .el-form-item.el-form-item--small {
    margin-bottom: 16px;
  }

  .el-form-item__label {
    color: #333 !important;
  }

  .el-form-item__content {

    // 日期时间选择器
    .el-date-editor--datetime .el-input__inner {
      padding: 0 30px !important;
    }
  }
}



.dialog-wrapper {
  .item {
    margin: 8px 0;

    .item-title {
      width: 200px;
    }

    .input {
      display: inline-block;
      vertical-align: middle;
      width: 330px;
    }
  }

  .remarks {
    // margin-top: 20px;
    width: 400px;
    // height: 44px;
    background: #fafafa;
    opacity: 1;
    line-height: 20px;
    padding: 12px 10px 10px 24px;
    font-size: 13px;
    position: relative;
    .img {
    display: inline-block;
    position: absolute;
    left: 8px;
    top: 15px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    }

    span {
      display: inline-block;
      margin-left: 25px;
      line-height: 20px;
    }
  }

  .remarksOne {
    padding: 10px;
    margin-top: 20px;
    width: 400px;
    // height: 80px;
    background: #fafafa;
    opacity: 1;

    // line-height: 44px;
    .boxText {
      // float: left;
      margin: -14px 0 0 20px;
    }

    .icon_i {
      display: inline-block;
      // position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #ffb95e;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      // top: 3px;
      // left: 10px;
    }
  }
}

.fx_btn {

  .select {
    width: 98px;
    height: 32px;
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .keep {
    width: 98px;
    height: 32px;
    margin: 0 10px 0 8px;
    cursor: pointer;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

/deep/ .el-dialog__body{
  padding: 20px 30px !important;
}
.message-zindex {
  z-index: 999999999999 !important;
}
</style>
